/* eslint-disable */
import type { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string };
  String: { input: string; output: string };
  Boolean: { input: boolean; output: boolean };
  Int: { input: number; output: number };
  Float: { input: number; output: number };
  Blob: { input: any; output: any };
  Date: { input: any; output: any };
  DateTime: { input: any; output: any };
  JSONObject: { input: any; output: any };
  Long: { input: any; output: any };
  PhoneNumber: { input: any; output: any };
  TimeIntervalInMillis: { input: any; output: any };
  TimestampInMillis: { input: any; output: any };
};

export type AiVideoTags = {
  __typename?: 'AIVideoTags';
  seatbelt_detection?: Maybe<SeatbeltDetection>;
};

export type AccessPoints = {
  __typename?: 'AccessPoints';
  /** The wifi list for the fleet. */
  access_points?: Maybe<Array<Maybe<WifiSetting>>>;
};

export type AcessibleFleets = {
  __typename?: 'AcessibleFleets';
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type ActivationTask = {
  __typename?: 'ActivationTask';
  category: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type ActivationTaskInput = {
  categories?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type ActivitiesSummary = {
  __typename?: 'ActivitiesSummary';
  completed: ExecutionDigestSummary;
  not_completed: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
  waiting: ExecutionDigestSummary;
};

export type ActivitiesSummaryInput = {
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Activity = {
  __typename?: 'Activity';
  additional_info?: Maybe<Scalars['String']['output']>;
  arrival_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  completion_status?: Maybe<ActivityCompletionStatus>;
  created_at: Scalars['TimestampInMillis']['output'];
  destination: Destination;
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  planned_distance_in_meters?: Maybe<Scalars['Int']['output']>;
  planned_duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  position?: Maybe<Scalars['Int']['output']>;
  proof_of_conclusion?: Maybe<OldProofOfConclusion>;
  route_id?: Maybe<Scalars['ID']['output']>;
  route_name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
  visit_status: ActivityVisitStatus;
  waiting_time?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
};

export enum ActivityCompletionStatus {
  Completed = 'COMPLETED',
  NotCompleted = 'NOT_COMPLETED',
  PartiallyCompleted = 'PARTIALLY_COMPLETED',
  Planned = 'PLANNED',
}

export type ActivityReport = {
  __typename?: 'ActivityReport';
  completion_status?: Maybe<ActivityCompletionStatus>;
  destination: Destination;
  driver?: Maybe<Driver>;
  duration: PlannedVsExecutedDurationTimeInMillis;
  end_time: PlannedVsExecutedTimestampInMillis;
  id: Scalars['ID']['output'];
  instructions?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  observations?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_time: PlannedVsExecutedTimestampInMillis;
  time_windows?: Maybe<Array<TimeWindow>>;
  type: ActivityType;
  vehicle?: Maybe<VehicleDto>;
  visit_status: ActivityVisitStatus;
};

export enum ActivityRouteRelation {
  ActivitiesWithinRoute = 'ACTIVITIES_WITHIN_ROUTE',
  ActivitiesWithoutRoute = 'ACTIVITIES_WITHOUT_ROUTE',
  AllActivities = 'ALL_ACTIVITIES',
}

export enum ActivityType {
  End = 'END',
  Start = 'START',
  Stop = 'STOP',
}

export type ActivityUpdate = {
  id?: InputMaybe<Scalars['ID']['input']>;
  input_activity?: InputMaybe<InputActivity>;
  type?: InputMaybe<ActivityType>;
};

export type ActivityVehicleAssociationInput = {
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export enum ActivityVisitStatus {
  NotVisited = 'NOT_VISITED',
  OnSite = 'ON_SITE',
  Pending = 'PENDING',
  Visited = 'VISITED',
}

export type AdasEvents = {
  __typename?: 'AdasEvents';
  forward_collision_warning: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
};

export type AdasEventsInput = {
  forward_collision_warning: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
};

export type AddDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type AddressInformation = {
  __typename?: 'AddressInformation';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

export type AggregatedSpeedEventsSummary = {
  __typename?: 'AggregatedSpeedEventsSummary';
  highEvents: Scalars['Int']['output'];
  higherEvents: Scalars['Int']['output'];
  mediumEvents: Scalars['Int']['output'];
  totalEvents: Scalars['Int']['output'];
};

export type AssociatedContact = {
  __typename?: 'AssociatedContact';
  email?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  phone?: Maybe<Scalars['String']['output']>;
};

export type AssociationConfig = {
  __typename?: 'AssociationConfig';
  entire_fleet_association_config?: Maybe<EntireFleetAssociationConfig>;
};

export type AssociationConfigInput = {
  entire_fleet_association_config: EntireFleetAssociationConfigInput;
};

export type AudioCoachingDevicesInfo = {
  __typename?: 'AudioCoachingDevicesInfo';
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type AudioCoachingDevicesInfoPage = {
  __typename?: 'AudioCoachingDevicesInfoPage';
  content?: Maybe<Array<Maybe<AudioCoachingDevicesInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type AudioFileResponse = {
  __typename?: 'AudioFileResponse';
  /** Public HTTPS URL to download the audio file from S3. */
  audioUrl: Scalars['String']['output'];
};

export enum AudioStatus {
  High = 'HIGH',
  Low = 'LOW',
  Medium = 'MEDIUM',
  Off = 'OFF',
  /** ON is deprecated and should be replaced with LOW, MEDIUM or HIGH */
  On = 'ON',
}

export type AvgFuelConsumptionAndCostPerKmResponse = {
  __typename?: 'AvgFuelConsumptionAndCostPerKmResponse';
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  chartGroup?: Maybe<Scalars['String']['output']>;
  endInterval: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
};

export type BatchCreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionInput = {
  plates?: InputMaybe<Array<Scalars['String']['input']>>;
  vins?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type BatchSuggestionsResponse = {
  __typename?: 'BatchSuggestionsResponse';
  results: Array<VehicleSuggestionEntry>;
};

export type Billet = {
  __typename?: 'Billet';
  barCode?: Maybe<Scalars['String']['output']>;
  boletoLink?: Maybe<Scalars['String']['output']>;
  cardCode?: Maybe<Scalars['String']['output']>;
  cardName?: Maybe<Scalars['String']['output']>;
  dataEmissao?: Maybe<Scalars['String']['output']>;
  dataVencimento?: Maybe<Scalars['String']['output']>;
  datePayment?: Maybe<Scalars['String']['output']>;
  diaProRata?: Maybe<Scalars['String']['output']>;
  digitableLine?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['Int']['output']>;
  idCompany?: Maybe<Scalars['Long']['output']>;
  idContract?: Maybe<Scalars['String']['output']>;
  idDoc?: Maybe<Scalars['String']['output']>;
  nfeDataEmissao?: Maybe<Scalars['String']['output']>;
  nfeHoraEmissao?: Maybe<Scalars['String']['output']>;
  nfeIdContract?: Maybe<Scalars['String']['output']>;
  nfeLink?: Maybe<Scalars['String']['output']>;
  nfeTitleValue?: Maybe<Scalars['String']['output']>;
  nrDocEntry?: Maybe<Scalars['String']['output']>;
  nrDocumento?: Maybe<Scalars['String']['output']>;
  nrNfse?: Maybe<Scalars['String']['output']>;
  nrNoteEntry?: Maybe<Scalars['String']['output']>;
  payedValue?: Maybe<Scalars['String']['output']>;
  runnedAt?: Maybe<Scalars['Int']['output']>;
  seqCode?: Maybe<Scalars['String']['output']>;
  source?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  titleValue?: Maybe<Scalars['String']['output']>;
  validFrom?: Maybe<Scalars['DateTime']['output']>;
  validTo?: Maybe<Scalars['DateTime']['output']>;
};

export type Branding = {
  __typename?: 'Branding';
  brand?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
};

export type BrandingInput = {
  brand?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export enum CacheControlScope {
  Private = 'PRIVATE',
  Public = 'PUBLIC',
}

export type CameraConfigurationInfo = {
  __typename?: 'CameraConfigurationInfo';
  /** The status of the camera audio. */
  audio_status?: Maybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** The duty type of the vehicle. */
  duty_type?: Maybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: Maybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: Maybe<Scalars['Float']['output']>;
  /** Last time that the camera changed from config in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

export type CameraConfigurationInfoPage = {
  __typename?: 'CameraConfigurationInfoPage';
  content?: Maybe<Array<Maybe<CameraConfigurationInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type CameraConfigurationUpdateInput = {
  /** The status of the camera audio. */
  audio_status?: InputMaybe<AudioStatus>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** Recording resolution of the camera */
  recording_resolution?: InputMaybe<RecordingResolution>;
  /** The desired speed limit to audio warning */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type CameraEventsConfiguration = {
  __typename?: 'CameraEventsConfiguration';
  entire_fleet_camera_events_configuration: EventsConfiguration;
};

export type Category = {
  __typename?: 'Category';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CategoryCost = {
  __typename?: 'CategoryCost';
  cost: Scalars['Float']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type CheckContent = {
  __typename?: 'CheckContent';
  checked?: Maybe<Scalars['Boolean']['output']>;
};

export type Checklist = {
  __typename?: 'Checklist';
  completed_count?: Maybe<Scalars['Int']['output']>;
  context?: Maybe<Context>;
  created_at: Scalars['Float']['output'];
  created_by: Scalars['String']['output'];
  fields: Array<Field>;
  groups: Array<ChecklistConfiguredGroup>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  template: Scalars['Boolean']['output'];
  template_active?: Maybe<Scalars['Boolean']['output']>;
  template_created_at?: Maybe<Scalars['Float']['output']>;
  template_created_by?: Maybe<Scalars['String']['output']>;
  template_id?: Maybe<Scalars['String']['output']>;
  vehicle_group_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicle_ids?: Maybe<Array<Scalars['ID']['output']>>;
  vehicles: Array<ChecklistConfiguredVehicle>;
  version: Scalars['Int']['output'];
};

export type ChecklistConfiguredGroup = {
  __typename?: 'ChecklistConfiguredGroup';
  id: Scalars['ID']['output'];
  path: Scalars['String']['output'];
};

export type ChecklistConfiguredVehicle = {
  __typename?: 'ChecklistConfiguredVehicle';
  group_id?: Maybe<Scalars['ID']['output']>;
  group_path: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type ChecklistVehicle = {
  __typename?: 'ChecklistVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  device_id: Scalars['String']['output'];
  group_id?: Maybe<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type ChecklistsNames = {
  __typename?: 'ChecklistsNames';
  names: Array<Maybe<Scalars['String']['output']>>;
};

export type ChecklistsPage = {
  __typename?: 'ChecklistsPage';
  page: PaginatedChecklists;
};

export type ClientInformation = {
  __typename?: 'ClientInformation';
  additionalInformation?: Maybe<Scalars['String']['output']>;
  document?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
  secondaryPhone?: Maybe<Scalars['String']['output']>;
};

export type CoachingEvidence = {
  __typename?: 'CoachingEvidence';
  files?: Maybe<Array<Maybe<CoachingEvidenceFile>>>;
  id?: Maybe<Scalars['ID']['output']>;
  media?: Maybe<MediaResponse>;
  media_id?: Maybe<Scalars['ID']['output']>;
  safety_occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  type?: Maybe<CoachingEvidenceType>;
};

export type CoachingEvidenceFile = {
  __typename?: 'CoachingEvidenceFile';
  created_at?: Maybe<Scalars['DateTime']['output']>;
  file_timestamp?: Maybe<Scalars['Int']['output']>;
  file_type: CoachingFileType;
  file_url: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export enum CoachingEvidenceType {
  Media = 'MEDIA',
}

export type CoachingFeedback = {
  __typename?: 'CoachingFeedback';
  coaching_evidences?: Maybe<Array<Maybe<CoachingEvidence>>>;
  created_at: Scalars['DateTime']['output'];
  created_by_user?: Maybe<FleetUser>;
  driver?: Maybe<Driver>;
  feedback_action?: Maybe<CoachingFeedbackAction>;
  id: Scalars['ID']['output'];
  note?: Maybe<Scalars['String']['output']>;
  note_author?: Maybe<FleetUser>;
  note_created_at?: Maybe<Scalars['DateTime']['output']>;
  status: CoachingFeedbackStatus;
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  updated_by_user?: Maybe<FleetUser>;
};

export enum CoachingFeedbackAction {
  Dismissal = 'DISMISSAL',
  Guidance = 'GUIDANCE',
  NoAction = 'NO_ACTION',
  Suspension = 'SUSPENSION',
  Warning = 'WARNING',
}

export type CoachingFeedbackInput = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  fromUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  status?: InputMaybe<Array<InputMaybe<CoachingFeedbackStatus>>>;
  toUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type CoachingFeedbackPage = {
  __typename?: 'CoachingFeedbackPage';
  content?: Maybe<Array<Maybe<CoachingFeedback>>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export enum CoachingFeedbackStatus {
  AddingEvidences = 'ADDING_EVIDENCES',
  Applying = 'APPLYING',
  Finished = 'FINISHED',
}

export enum CoachingFileType {
  CustomUpload = 'CUSTOM_UPLOAD',
  Thumbnail = 'THUMBNAIL',
  VideoFrame = 'VIDEO_FRAME',
}

export type CoblerInformation = {
  __typename?: 'CoblerInformation';
  contactResponsible?: Maybe<Scalars['String']['output']>;
  responsible?: Maybe<Scalars['String']['output']>;
  schedulingResponsible?: Maybe<Scalars['String']['output']>;
  technicianResponsible?: Maybe<Scalars['String']['output']>;
};

export type ColumnMapEntryInput = {
  key: Scalars['String']['input'];
  value: ColumnMapInput;
};

export type ColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export enum ConditionCategory {
  DeviceHealthStatusObservationPeriodNormal = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL',
  DeviceHealthStatusObservationPeriodNormalUnavailable = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_NORMAL_UNAVAILABLE',
  DeviceHealthStatusObservationPeriodUnavailable = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD_UNAVAILABLE',
  GeofenceIn = 'GEOFENCE_IN',
  GeofenceInOut = 'GEOFENCE_IN_OUT',
  GeofenceOut = 'GEOFENCE_OUT',
  IdleEngine_3Minutes = 'IDLE_ENGINE_3_MINUTES',
  IdleEngine_5Minutes = 'IDLE_ENGINE_5_MINUTES',
  IdleEngine_10Minutes = 'IDLE_ENGINE_10_MINUTES',
  IdleEngine_15Minutes = 'IDLE_ENGINE_15_MINUTES',
  IdleEngine_30Minutes = 'IDLE_ENGINE_30_MINUTES',
}

export type ContactInformation = {
  __typename?: 'ContactInformation';
  bestContactTime?: Maybe<Scalars['String']['output']>;
  bestWayToContact?: Maybe<Scalars['String']['output']>;
  contactMethod?: Maybe<Scalars['String']['output']>;
  contactMethodForResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type Context = {
  __typename?: 'Context';
  address?: Maybe<Scalars['String']['output']>;
  app_version: Scalars['String']['output'];
  vehicle?: Maybe<ChecklistVehicle>;
};

export type Coordinate = {
  __typename?: 'Coordinate';
  latitude: Scalars['Float']['output'];
  longitude: Scalars['Float']['output'];
};

export type CoordinateInput = {
  latitude: Scalars['Float']['input'];
  longitude: Scalars['Float']['input'];
};

export type CreateCheckpointManualInput = {
  odometerInKm: Scalars['Long']['input'];
  odometerReferenceDate: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type CreateFleetAudioMessageInput = {
  /** The text content to be converted to audio using text-to-speech. */
  message: Scalars['String']['input'];
  /** Optional name/identifier for the audio message. */
  name?: InputMaybe<Scalars['String']['input']>;
};

export type CreateFuelTransactionInput = {
  costCenterDescription?: InputMaybe<Scalars['String']['input']>;
  costCenterId?: InputMaybe<Scalars['String']['input']>;
  createdBy?: InputMaybe<Scalars['String']['input']>;
  driverName?: InputMaybe<Scalars['String']['input']>;
  fuelType: Scalars['String']['input'];
  integrationId?: InputMaybe<Scalars['ID']['input']>;
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type CreateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  reminderId?: InputMaybe<Scalars['ID']['input']>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
  types: Array<InputMaybe<Scalars['String']['input']>>;
  vehicleId: Scalars['ID']['input'];
};

export type CreateMaintenancePartsInput = {
  description: Scalars['String']['input'];
};

export type CreateManualOdometerResponse = {
  __typename?: 'CreateManualOdometerResponse';
  manualOdometer: ManualOdometer;
  vehicle: VehicleDto;
};

export type CreateMediaRequest = {
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: InputMaybe<Scalars['String']['input']>;
  /**
   * Enable email notification when the requested media is available.
   * If empty will be considered as false.
   */
  enable_email_notification?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['input'];
  /**
   * Allow a full timelapse media of the selected period.
   * If empty it will be considered false.
   */
  is_timelapse?: InputMaybe<Scalars['Boolean']['input']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['input'];
  /** Trip identifier. */
  trip_id?: InputMaybe<Scalars['String']['input']>;
  /** Vehicle identifier. An UUID */
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type CreateMediaResponse = {
  __typename?: 'CreateMediaResponse';
  /** Device identifier. A string between 10 and 15 characters. */
  device_id?: Maybe<Scalars['String']['output']>;
  /** List of emails that will be notified when the request is completed. */
  emails_to_notify?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Desired media end Unix timestamp in millis. */
  end_time: Scalars['TimestampInMillis']['output'];
  /** MediaId from the created media. */
  media_id?: Maybe<Scalars['ID']['output']>;
  /** Desired media start Unix timestamp in millis. */
  start_time: Scalars['TimestampInMillis']['output'];
  /** Vehicle identifier. An UUID */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type CreateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
  vehicles: Array<CreateReminderVehicleInput>;
};

export type CreateReminderVehicleInput = {
  id: Scalars['ID']['input'];
  nextRecurrenceDate?: InputMaybe<Scalars['DateTime']['input']>;
  nextRecurrenceInKm?: InputMaybe<Scalars['Float']['input']>;
};

export type CreateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  branding?: InputMaybe<BrandingInput>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuel?: InputMaybe<FuelInput>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  installedDeviceId?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Int']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type CreateVehiclesBatchInput = {
  vehicles: Array<BatchCreateVehicleInput>;
};

export type CrmOrder = {
  __typename?: 'CrmOrder';
  associatedContact?: Maybe<AssociatedContact>;
  createdAt?: Maybe<Scalars['String']['output']>;
  deletedAt?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  orderClass?: Maybe<Scalars['String']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  tickets?: Maybe<Array<Maybe<ITicket>>>;
};

export type CustomDashboard = {
  __typename?: 'CustomDashboard';
  description: Scalars['String']['output'];
  externalDashboardId: Scalars['String']['output'];
  filters: Array<CustomDashboardFilter>;
  fleets: Array<CustomDashboardFleet>;
  id: Scalars['ID']['output'];
  isPublic: Scalars['Boolean']['output'];
  name: Scalars['String']['output'];
};

export type CustomDashboardFilter = {
  __typename?: 'CustomDashboardFilter';
  filterKey: Scalars['String']['output'];
  filterName: Scalars['String']['output'];
};

export type CustomDashboardFleet = {
  __typename?: 'CustomDashboardFleet';
  fleetId: Scalars['ID']['output'];
  groupsRestrictions: Array<Scalars['String']['output']>;
};

export type DateInformation = {
  __typename?: 'DateInformation';
  installedDate?: Maybe<Scalars['String']['output']>;
  preferredDay1?: Maybe<Scalars['String']['output']>;
  preferredDay2?: Maybe<Scalars['String']['output']>;
  preferredDay3?: Maybe<Scalars['String']['output']>;
  preferredHour1?: Maybe<Scalars['String']['output']>;
  preferredHour2?: Maybe<Scalars['String']['output']>;
  preferredHour3?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  scheduledHour?: Maybe<Scalars['String']['output']>;
};

export type DateRange = {
  end: Scalars['Float']['input'];
  start: Scalars['Float']['input'];
};

export type DeleteActivitiesIds = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type DeleteChecklist = {
  id: Scalars['ID']['input'];
};

export type DeleteDriver = {
  id: Scalars['ID']['input'];
};

export type DeleteFuelTransactionsInput = {
  transactionIds: Array<Scalars['ID']['input']>;
};

export type DeleteMaintenanceHistoryInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenancePartsInput = {
  id: Scalars['ID']['input'];
};

export type DeleteMaintenanceReminderInput = {
  id: Scalars['ID']['input'];
};

export type DeleteRoutesInput = {
  ids: Array<Scalars['ID']['input']>;
  propagation_type?: InputMaybe<Scalars['String']['input']>;
};

export type Destination = {
  __typename?: 'Destination';
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type DestinationInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  coordinate: CoordinateInput;
  country?: InputMaybe<Scalars['String']['input']>;
  neighborhood?: InputMaybe<Scalars['String']['input']>;
  postal_code?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  street_address?: InputMaybe<Scalars['String']['input']>;
  street_complement?: InputMaybe<Scalars['String']['input']>;
  street_number?: InputMaybe<Scalars['String']['input']>;
};

export type Device = {
  __typename?: 'Device';
  activeObservationPeriodTrigger?: Maybe<Trigger>;
  associatedAt: Scalars['DateTime']['output'];
  cobliId: Scalars['String']['output'];
  deviceModel?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerStatus>;
  fleetId: Scalars['ID']['output'];
  generalStatus: DeviceGeneralStatus;
  generalType: DeviceGeneralType;
  healthStatus: DeviceHealthStatusType;
  id: Scalars['String']['output'];
  isNew: Scalars['Boolean']['output'];
  lastLocation?: Maybe<LastLocation>;
  lastMovingStateTime?: Maybe<Scalars['String']['output']>;
  sdCardHealthStatus?: Maybe<DeviceSdCardHealthStatus>;
  statusSummary: DeviceStatusSummary;
  tracking?: Maybe<DeviceTracking>;
  type: DeviceType;
  vehicle?: Maybe<VehicleDto>;
  vehicleDissociatedAt?: Maybe<Scalars['DateTime']['output']>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export type DeviceCause = {
  __typename?: 'DeviceCause';
  cause: DeviceCauseKey;
  status: DeviceStatusType;
};

export enum DeviceCauseKey {
  Damaged = 'DAMAGED',
  Disconnected = 'DISCONNECTED',
  InDevolution = 'IN_DEVOLUTION',
  LosingData = 'LOSING_DATA',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  SdCardProblem = 'SD_CARD_PROBLEM',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
}

export type DeviceConfiguration = {
  __typename?: 'DeviceConfiguration';
  actual_parameters?: Maybe<Array<Parameter>>;
  device: DeviceDetails;
  id: Scalars['String']['output'];
  target_parameters?: Maybe<Array<Parameter>>;
};

export type DeviceDestination = {
  __typename?: 'DeviceDestination';
  address?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
};

export type DeviceDetails = {
  __typename?: 'DeviceDetails';
  associated_at: Scalars['DateTime']['output'];
  chip_number: Scalars['String']['output'];
  chip_operator: Scalars['String']['output'];
  cobli_id: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  icc_id: Scalars['String']['output'];
  id: Scalars['String']['output'];
  imei: Scalars['String']['output'];
  status: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type DeviceFields = {
  __typename?: 'DeviceFields';
  cobliId: Scalars['String']['output'];
  lastLocation: LastLocation;
  type: Scalars['String']['output'];
};

export enum DeviceGeneralStatus {
  Damaged = 'DAMAGED',
  Disconnected = 'DISCONNECTED',
  InDevolution = 'IN_DEVOLUTION',
  LosingData = 'LOSING_DATA',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
}

export enum DeviceGeneralType {
  Blocker = 'BLOCKER',
  Can = 'CAN',
  CanIbutton = 'CAN_IBUTTON',
  CanIbuttonImmobilizer = 'CAN_IBUTTON_IMMOBILIZER',
  Dashcam = 'DASHCAM',
  Fake = 'FAKE',
  Ibutton = 'IBUTTON',
  IbuttonImmobilizer = 'IBUTTON_IMMOBILIZER',
  Immobilizer = 'IMMOBILIZER',
  Installed = 'INSTALLED',
  Multicam = 'MULTICAM',
  PlugAndPlay = 'PLUG_AND_PLAY',
  PlugAndPlayIbutton = 'PLUG_AND_PLAY_IBUTTON',
  Removable = 'REMOVABLE',
  Unknown = 'UNKNOWN',
}

export enum DeviceHealthStatusType {
  Damaged = 'DAMAGED',
  DeviceWithoutFleet = 'DEVICE_WITHOUT_FLEET',
  Disconnected = 'DISCONNECTED',
  Normal = 'NORMAL',
  NoSignal = 'NO_SIGNAL',
  NoSufficientData = 'NO_SUFFICIENT_DATA',
  Syncing = 'SYNCING',
  Unavailable = 'UNAVAILABLE',
  Unknown = 'UNKNOWN',
}

export enum DeviceSdCardHealthStatus {
  Ok = 'OK',
  SdCardProblem = 'SD_CARD_PROBLEM',
}

export type DeviceShippingInformation = {
  __typename?: 'DeviceShippingInformation';
  quantidadeChaveiroString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesBloqueadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2ProString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamGeracao2String?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosCobliCamString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosImobilizadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoLevesOuPesadosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosClienteString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioInstaladoMotosOuMaquinariosString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosBuzzerString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesOuPesadosIdentificadorString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelLevesString?: Maybe<Scalars['Int']['output']>;
  quantidadeEnvioRemovivelPesadosString?: Maybe<Scalars['Int']['output']>;
};

export type DeviceStatusSubscription = {
  __typename?: 'DeviceStatusSubscription';
  active: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  user_id: Scalars['ID']['output'];
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
  vehicle_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type DeviceStatusSubscriptionInput = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  vehicle_group_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicle_ids?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type DeviceStatusSummary = {
  __typename?: 'DeviceStatusSummary';
  causes: Array<DeviceCause>;
  status: DeviceStatusType;
};

export enum DeviceStatusType {
  Check = 'CHECK',
  Critical = 'CRITICAL',
  Healthy = 'HEALTHY',
}

export type DeviceTotalQuantity = {
  __typename?: 'DeviceTotalQuantity';
  camera?: Maybe<Scalars['Int']['output']>;
  identifiers?: Maybe<Scalars['Int']['output']>;
  immobilizer?: Maybe<Scalars['Int']['output']>;
  installed?: Maybe<Scalars['Int']['output']>;
  redeCan?: Maybe<Scalars['Int']['output']>;
  removable?: Maybe<Scalars['Int']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type DeviceTracking = {
  __typename?: 'DeviceTracking';
  conclusionTime?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<DeviceDestination>;
  tempGeofenceId?: Maybe<Scalars['String']['output']>;
};

export enum DeviceType {
  Blocker = 'Blocker',
  Buzzer = 'Buzzer',
  Can = 'Can',
  CanIbutton = 'CanIbutton',
  CanIbuttonImmobillizer = 'CanIbuttonImmobillizer',
  Dashcam = 'Dashcam',
  Immobilizer = 'Immobilizer',
  Multicam = 'Multicam',
  Obd = 'OBD',
  ObdRemovable = 'OBD_Removable',
  PlugAndPlayBuzzer = 'PlugAndPlayBuzzer',
  Solar = 'Solar',
  Unknown = 'Unknown',
  IButton = 'iButton',
  IButtonImmobilizer = 'iButtonImmobilizer',
}

export type DeviceVehicle = {
  __typename?: 'DeviceVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  id: Scalars['String']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type DevolutionClientInformation = {
  __typename?: 'DevolutionClientInformation';
  clientCnpj?: Maybe<Scalars['String']['output']>;
};

export type DevolutionDeviceInformation = {
  __typename?: 'DevolutionDeviceInformation';
  devolutionDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devolutionDevicesEsn?: Maybe<Scalars['String']['output']>;
  devolutionDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  heavyDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledCoblicamQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableBuzzerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightDevolutionRemovableIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  lightDevolutionRemovableQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledClientQuantity?: Maybe<Scalars['Int']['output']>;
  motorcycleOrMachineryDevolutionInstalledQuantity?: Maybe<Scalars['Int']['output']>;
};

export type DevolutionDeviceTickets = {
  __typename?: 'DevolutionDeviceTickets';
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  devolutionTickets: Tickets;
  fleetId: Scalars['String']['output'];
};

export type DevolutionInformation = {
  __typename?: 'DevolutionInformation';
  clientInformation?: Maybe<DevolutionClientInformation>;
  deviceInformation?: Maybe<DevolutionDeviceInformation>;
  devolutionDeadline?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  fleetName?: Maybe<Scalars['String']['output']>;
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  shippingInformation?: Maybe<DevolutionShippingInformation>;
  supplyDevolucaoTipo?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type DevolutionShippingInformation = {
  __typename?: 'DevolutionShippingInformation';
  devolutionArrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  devolutionPostageDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingCode?: Maybe<Scalars['String']['output']>;
  devolutionShippingCodeOrScheduleDate?: Maybe<Scalars['String']['output']>;
  devolutionShippingType?: Maybe<Scalars['String']['output']>;
};

export type DisablerDto = {
  __typename?: 'DisablerDTO';
  lastDisablingAction?: Maybe<Scalars['String']['output']>;
  lastDisablingActionTime?: Maybe<Scalars['Float']['output']>;
  status?: Maybe<Scalars['String']['output']>;
};

export enum DisablerStatus {
  DisablePending = 'DisablePending',
  Disabled = 'Disabled',
  Disabling = 'Disabling',
  EnablePending = 'EnablePending',
  Enabled = 'Enabled',
}

export type DmsEvents = {
  __typename?: 'DmsEvents';
  distracted_driving: SensibilityConfiguration;
  eyes_closed: SensibilityConfiguration;
  min_speed_trigger_in_km_per_h: Scalars['Int']['output'];
  phone_usage: SensibilityConfiguration;
  smoking: SensibilityConfiguration;
  yawn: SensibilityConfiguration;
};

export type DmsEventsInput = {
  distracted_driving: SensibilityConfigurationInput;
  eyes_closed: SensibilityConfigurationInput;
  min_speed_trigger_in_km_per_h: Scalars['Int']['input'];
  phone_usage: SensibilityConfigurationInput;
  smoking: SensibilityConfigurationInput;
  yawn: SensibilityConfigurationInput;
};

export type Driver = {
  __typename?: 'Driver';
  active?: Maybe<Scalars['Boolean']['output']>;
  assigned?: Maybe<Scalars['Boolean']['output']>;
  cpf?: Maybe<Scalars['String']['output']>;
  driver_code?: Maybe<Scalars['String']['output']>;
  driver_license?: Maybe<Scalars['String']['output']>;
  first_license_acquirement_date?: Maybe<Scalars['Date']['output']>;
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  identification_token?: Maybe<IdentificationTokenV2>;
  /** @deprecated Use `identification_token` field instead. */
  identifier?: Maybe<Scalars['String']['output']>;
  license_category?: Maybe<LicenseCategory>;
  license_expiration_date?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  registry_id?: Maybe<Scalars['String']['output']>;
  score?: Maybe<DriverScore>;
  vehicle?: Maybe<VehicleDto>;
};

export type DriverAssignmentInput = {
  deviceId?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['String']['input']>;
  source?: InputMaybe<Scalars['String']['input']>;
};

export type DriverAuthorization = {
  __typename?: 'DriverAuthorization';
  authorizationId: Scalars['ID']['output'];
  device?: Maybe<Device>;
  driver: Driver;
  identificationToken?: Maybe<IdentificationTokenV2>;
};

export type DriverFaceClusterUpdate = {
  /** Driver Face Cluster id. UUID */
  driver_face_cluster_id?: InputMaybe<Scalars['ID']['input']>;
  /** Driver identifier. UUID */
  driver_id?: InputMaybe<Scalars['ID']['input']>;
};

export type DriverFaceClustersInfo = {
  __typename?: 'DriverFaceClustersInfo';
  /** Time that the Driver Face Cluster was created in RFC 3339 format */
  created_at: Scalars['DateTime']['output'];
  /** Cobli driver identifier assigned to the cluster. */
  driver?: Maybe<Driver>;
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
  /** Number of Driver Face Cluster image URLs. Represents how many images are present in the list of sample_image_urls. */
  sample_image_url_count: Scalars['Int']['output'];
  /** Driver Face Cluster list of images URL. A list of images URL */
  sample_image_urls: Array<Maybe<DriverPhoto>>;
  /** The suggested driver for this unnamed cluster. */
  suggested_driver?: Maybe<Driver>;
  /** Last time that the Driver Face Cluster was updated in RFC 3339 format */
  updated_at?: Maybe<Scalars['DateTime']['output']>;
};

/** DriverFaceCluster data for the media */
export type DriverFaceClustersMedia = {
  __typename?: 'DriverFaceClustersMedia';
  /** Cobli driver. */
  driver?: Maybe<Driver>;
  /** Cobli driver identifier assigned to the cluster. An UUID */
  driver_id: Scalars['ID']['output'];
  /** Driver Face Cluster identifier. An UUID */
  id: Scalars['ID']['output'];
  /** Driver Face Cluster image profile URL. An URL */
  profile_image_url: DriverPhoto;
};

export type DriverFaceClustersSuggestion = {
  __typename?: 'DriverFaceClustersSuggestion';
  /** The candidate clusters for the driver */
  candidate_clusters: Array<Maybe<DriverFaceClustersInfo>>;
  /** Cobli driver suggested to the candidate clusters. */
  driver?: Maybe<Driver>;
};

export type DriverInput = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  assigned?: InputMaybe<Scalars['Boolean']['input']>;
  driver_code?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  fleet_id: Scalars['ID']['input'];
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<LicenseCategory>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['PhoneNumber']['input']>;
  score?: InputMaybe<DriverScoreInput>;
};

export type DriverLastAssociation = {
  __typename?: 'DriverLastAssociation';
  associatedAt?: Maybe<Scalars['String']['output']>;
  deviceId: Scalars['String']['output'];
  driverId?: Maybe<Scalars['String']['output']>;
  driverName?: Maybe<Scalars['String']['output']>;
};

export type DriverNominateTripImageInput = {
  /** The id of the driver. */
  driver_id?: InputMaybe<Scalars['String']['input']>;
  /** A feedback from the user marking that the driver is visible or not */
  driver_visibility?: InputMaybe<DriverVisibility>;
  /** The id of the image. */
  image_id: Scalars['String']['input'];
  /** The signed url of the image. */
  image_url?: InputMaybe<Scalars['String']['input']>;
  /** The operation. */
  operation: NominationOperation;
  /** The id of the trip. */
  trip_id: Scalars['String']['input'];
};

/** Driver Face Cluster image profile URL. An URL */
export type DriverPhoto = {
  __typename?: 'DriverPhoto';
  /** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
  box?: Maybe<FaceBox>;
  /** An URL for a image profile URL. An URL */
  image_url: Scalars['String']['output'];
};

export type DriverScore = {
  __typename?: 'DriverScore';
  distance_driven?: Maybe<Scalars['Float']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  events_rates?: Maybe<EventRates>;
  score?: Maybe<Scalars['Float']['output']>;
  start_timestamp?: Maybe<Scalars['DateTime']['output']>;
};

export type DriverScoreInput = {
  distance_driven?: InputMaybe<Scalars['Float']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  events_rates?: InputMaybe<EventRatesInput>;
  score?: InputMaybe<Scalars['Float']['input']>;
  start_timestamp?: InputMaybe<Scalars['DateTime']['input']>;
};

export type DriverSpeedRow = {
  __typename?: 'DriverSpeedRow';
  driver: Driver;
  evolution: Scalars['Int']['output'];
  highEventsCount: Scalars['Int']['output'];
  higherEventsCount: Scalars['Int']['output'];
  kmsPerEvent: Scalars['Float']['output'];
  mediumEventsCount: Scalars['Int']['output'];
  percentageAboveLimit: Scalars['Float']['output'];
  totalEventsCount: Scalars['Int']['output'];
  totalTimeAboveLimitInMinutes: Scalars['Int']['output'];
  totalTripDurationInMinutes: Scalars['Int']['output'];
};

export type DriverSpeedRowInput = {
  driver_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_date: Scalars['String']['input'];
  event_type: Scalars['String']['input'];
  start_date: Scalars['String']['input'];
  timezone: Scalars['String']['input'];
};

export type DriverSpreadsheetResult = {
  __typename?: 'DriverSpreadsheetResult';
  invalid_rows?: Maybe<Array<InvalidDriverSheetRow>>;
  valid_rows?: Maybe<Array<MappedDriver>>;
};

export type DriverSpreadsheetRow = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['String']['input']>;
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['String']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export enum DriverVisibility {
  NotVisible = 'NOT_VISIBLE',
  Visible = 'VISIBLE',
}

export enum DutyType {
  Heavy = 'HEAVY',
  Light = 'LIGHT',
  Medium = 'MEDIUM',
}

export type EntireFleetAssociationConfig = {
  __typename?: 'EntireFleetAssociationConfig';
  is_on?: Maybe<Scalars['Boolean']['output']>;
};

export type EntireFleetAssociationConfigInput = {
  is_on: Scalars['Boolean']['input'];
};

export type EventRates = {
  __typename?: 'EventRates';
  fast_acceleration?: Maybe<Scalars['Float']['output']>;
  hard_break?: Maybe<Scalars['Float']['output']>;
  high_speed?: Maybe<Scalars['Float']['output']>;
  speedy_turn?: Maybe<Scalars['Float']['output']>;
};

export type EventRatesInput = {
  fast_acceleration?: InputMaybe<Scalars['Float']['input']>;
  hard_break?: InputMaybe<Scalars['Float']['input']>;
  high_speed?: InputMaybe<Scalars['Float']['input']>;
  speedy_turn?: InputMaybe<Scalars['Float']['input']>;
};

export enum EventTrigger {
  Anomaly = 'ANOMALY',
  Collision = 'COLLISION',
  DistractedDriving = 'DISTRACTED_DRIVING',
  EyesClosed = 'EYES_CLOSED',
  Fatigue = 'FATIGUE',
  FrontCollisionWarning = 'FRONT_COLLISION_WARNING',
  HarshAcceleration = 'HARSH_ACCELERATION',
  HarshBreaking = 'HARSH_BREAKING',
  HarshCornering = 'HARSH_CORNERING',
  LaneDrift = 'LANE_DRIFT',
  MaxSpeedExceeded = 'MAX_SPEED_EXCEEDED',
  PhoneUsage = 'PHONE_USAGE',
  Smoking = 'SMOKING',
  Sos = 'SOS',
  StopSignViolated = 'STOP_SIGN_VIOLATED',
  Tailgating = 'TAILGATING',
  TrafficSpeedViolated = 'TRAFFIC_SPEED_VIOLATED',
  Unknown = 'UNKNOWN',
  Yawn = 'YAWN',
}

export type EventVideo = {
  __typename?: 'EventVideo';
  /** Event trigger. */
  event_trigger: EventTrigger;
  /** Event latitude. */
  latitude: Scalars['Float']['output'];
  /** Event longitude. */
  longitude: Scalars['Float']['output'];
  /** The url of the content media. */
  media_url: Scalars['String']['output'];
  /** Event speed. */
  speed: Scalars['Float']['output'];
  /** Speed limit of the road. Only available when event trigger is TRAFFICSPEEDVIOLATED. */
  speed_sign?: Maybe<Scalars['Int']['output']>;
  /** The url to the thumbnail image of a video. */
  thumbnail_url: Scalars['String']['output'];
};

export type EventsConfiguration = {
  __typename?: 'EventsConfiguration';
  adas_events: AdasEvents;
  dms_events: DmsEvents;
  harsh_events: HarshEventsByDutyType;
  ignition_off_record_settings?: Maybe<Scalars['Int']['output']>;
};

export type EventsConfigurationInput = {
  adas_events: AdasEventsInput;
  dms_events: DmsEventsInput;
  harsh_events: HarshEventsByDutyTypeInput;
  ignition_off_record_settings?: InputMaybe<Scalars['Int']['input']>;
};

export type Expense = {
  __typename?: 'Expense';
  category: Category;
  createdAt: Scalars['DateTime']['output'];
  createdBy: Scalars['ID']['output'];
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['DateTime']['output'];
  source?: Maybe<Scalars['String']['output']>;
  supplier?: Maybe<Supplier>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle: ExpenseVehicle;
};

export type ExpensePaginatedResponse = {
  __typename?: 'ExpensePaginatedResponse';
  content: Array<Expense>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type ExpenseVehicle = {
  __typename?: 'ExpenseVehicle';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  groupName?: Maybe<Scalars['String']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  tagNames: Array<Scalars['String']['output']>;
};

export type ExpensesImportColumnMap = {
  categoryName?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  observation?: InputMaybe<ImportColumnMapInput>;
  occurredAt?: InputMaybe<ImportColumnMapInput>;
  supplierName?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
};

export type ExpensesListInput = {
  categoryIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  types?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** A FaceBox containing the coordinates of the face in the picture. A FaceBox */
export type FaceBox = {
  __typename?: 'FaceBox';
  x_max: Scalars['Int']['output'];
  x_min: Scalars['Int']['output'];
  y_max: Scalars['Int']['output'];
  y_min: Scalars['Int']['output'];
};

export type Field = {
  __typename?: 'Field';
  content: FieldContentType;
  id: Scalars['ID']['output'];
  photos_urls?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  required: Scalars['Boolean']['output'];
  should_request_photos?: Maybe<Scalars['Boolean']['output']>;
  title: Scalars['String']['output'];
  type: FieldType;
};

export type FieldContentType = CheckContent | SelectContent | TextContent;

export type FieldControlInformation = {
  __typename?: 'FieldControlInformation';
  fieldObservations?: Maybe<Scalars['String']['output']>;
  technicalTeamObservation?: Maybe<Scalars['String']['output']>;
};

export enum FieldType {
  Check = 'CHECK',
  MultiSelect = 'MULTI_SELECT',
  SingleSelect = 'SINGLE_SELECT',
  Text = 'TEXT',
}

export type Filters = {
  wantedAlertTypes?: InputMaybe<Array<InputMaybe<UserNotificationSettingsType>>>;
  wantedGroups?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type Fleet = {
  __typename?: 'Fleet';
  acceptance_terms?: Maybe<Scalars['JSONObject']['output']>;
  active?: Maybe<Scalars['Boolean']['output']>;
  global_score?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Manager>>>;
  name?: Maybe<Scalars['String']['output']>;
  periodical_scores?: Maybe<Scalars['JSONObject']['output']>;
};

export type FleetAudioMessage = {
  __typename?: 'FleetAudioMessage';
  /** Timestamp when the message was created in RFC 3339 format. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the message. */
  createdBy: User;
  /** Fleet identifier that owns this audio message. */
  fleetId: Scalars['ID']['output'];
  /** Unique identifier for the audio message. */
  id: Scalars['ID']['output'];
  /** The text content of the audio message. */
  message: Scalars['String']['output'];
  /** URL to the generated MP3 file stored in S3. */
  mp3Url: Scalars['String']['output'];
  /** Optional name/identifier for the audio message. */
  name?: Maybe<Scalars['String']['output']>;
};

export type FleetAudioMessagePlayback = {
  __typename?: 'FleetAudioMessagePlayback';
  /** The audio message ID that was played. */
  audioMessageId: Scalars['ID']['output'];
  /** Whether the playback will be auto-cancelled if not successfully delivered within 1 hour. */
  cancelIfTimeout?: Maybe<Scalars['Boolean']['output']>;
  /** Timestamp when the playback record was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The user who created the playback request. */
  createdBy: User;
  /** The device where the message was played. */
  device: Device;
  /** Optional driver associated with the playback. */
  driver?: Maybe<Driver>;
  /** Unique identifier for this playback record. */
  id: Scalars['ID']['output'];
  /** The audio message content/text. */
  message?: Maybe<Scalars['String']['output']>;
  /** Timestamp when the playback was successfully delivered. */
  playedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Number of retry attempts made for this playback. */
  retryCount: Scalars['Int']['output'];
  /** Current status of the playback (PENDING, SUCCESS, ERROR, or CANCELLED). */
  status: PlaybackStatus;
  /** The vehicle on which the message was played. */
  vehicle: VehicleDto;
};

export type FleetAudioMessagePlaybackPage = {
  __typename?: 'FleetAudioMessagePlaybackPage';
  /** List of playback records for the requested vehicle. */
  content?: Maybe<Array<Maybe<FleetAudioMessagePlayback>>>;
  /** Whether the page is empty. */
  empty?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the first page. */
  first?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this is the last page. */
  last?: Maybe<Scalars['Boolean']['output']>;
  /** Zero-based page index. */
  number?: Maybe<Scalars['Int']['output']>;
  /** Number of elements in this page. */
  numberOfElements?: Maybe<Scalars['Int']['output']>;
  /** Pagination metadata. */
  pageable?: Maybe<PageableObject>;
  /** The size of the page. */
  size?: Maybe<Scalars['Int']['output']>;
  /** Sorting information. */
  sort?: Maybe<SortType>;
  /** Total number of elements across all pages. */
  totalElements?: Maybe<Scalars['Int']['output']>;
  /** Total number of pages. */
  totalPages?: Maybe<Scalars['Int']['output']>;
};

export type FleetAutoAssociationSettings = {
  __typename?: 'FleetAutoAssociationSettings';
  association_config?: Maybe<AssociationConfig>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  last_updated_by?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type FleetCompanyContract = {
  __typename?: 'FleetCompanyContract';
  address?: Maybe<Scalars['String']['output']>;
  billingDay?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  companyId: Scalars['String']['output'];
  companyStatus: Scalars['String']['output'];
  contractSignedDate: Scalars['String']['output'];
  corporateName?: Maybe<Scalars['String']['output']>;
  dueDay?: Maybe<Scalars['String']['output']>;
  financialAdjustmentIndex?: Maybe<Scalars['String']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  lastRegistrationChangeDate?: Maybe<Scalars['String']['output']>;
  mrrCurrency?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<Scalars['String']['output']>;
  phone?: Maybe<Scalars['String']['output']>;
  recentConversionEventName?: Maybe<Scalars['String']['output']>;
  responsavel?: Maybe<Scalars['String']['output']>;
  upsellBlockLoggedArea?: Maybe<Scalars['String']['output']>;
};

export type FleetCompanyContracts = {
  __typename?: 'FleetCompanyContracts';
  contracts: Array<FleetCompanyContract>;
  fleetId: Scalars['ID']['output'];
};

export type FleetCompanyOnboardingStatus = {
  __typename?: 'FleetCompanyOnboardingStatus';
  hasAnyContractSignedInLast90Days: Scalars['Boolean']['output'];
  hasAnyOnboardingContract: Scalars['Boolean']['output'];
};

export type FleetEventsConfiguration = {
  __typename?: 'FleetEventsConfiguration';
  camera_events_config?: Maybe<CameraEventsConfiguration>;
  created_at: Scalars['String']['output'];
  fleet_id: Scalars['ID']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
  updated_by_id?: Maybe<Scalars['ID']['output']>;
  updated_by_name?: Maybe<Scalars['String']['output']>;
};

export type FleetProducts = {
  __typename?: 'FleetProducts';
  products?: Maybe<Array<Maybe<Product>>>;
};

export type FleetUser = {
  __typename?: 'FleetUser';
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email_address?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['String']['output']>;
  full_name?: Maybe<Scalars['String']['output']>;
  granted_permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_custom_permissions?: Maybe<Scalars['Boolean']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone_offset?: Maybe<Scalars['String']['output']>;
};

export type FleetVehicleGroups = {
  __typename?: 'FleetVehicleGroups';
  created_at: Scalars['TimestampInMillis']['output'];
  creator_id: Scalars['ID']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updated_at: Scalars['TimeIntervalInMillis']['output'];
  vehicle_ids: Array<Scalars['ID']['output']>;
};

export type FootageVideo = {
  __typename?: 'FootageVideo';
  /** Unix timestamp in millis of request creation. */
  created_at: Scalars['TimestampInMillis']['output'];
  /** Information of the user that requested the media. */
  created_by?: Maybe<FleetUser>;
  /** Information of the fleet policy trigger that requested the media. */
  created_by_trigger?: Maybe<MediaRequestTrigger>;
  /** Media duration in seconds */
  duration: Scalars['TimestampInMillis']['output'];
  /** Footage end latitude. Only available if the media has been uploaded. */
  end_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage end longitude. Only available if the media has been uploaded. */
  end_longitude?: Maybe<Scalars['Float']['output']>;
  /** The url of the content media. Only available if the media has been uploaded. */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status processing. */
  processed_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** Request id of the footage. */
  request_id: Scalars['String']['output'];
  /** Status of footage request. */
  request_status: MediaRequestStatus;
  /** Footage start latitude. Only available if the media has been uploaded. */
  start_latitude?: Maybe<Scalars['Float']['output']>;
  /** Footage start longitude. Only available if the media has been uploaded. */
  start_longitude?: Maybe<Scalars['Float']['output']>;
  /**
   * Status of footage request.
   * @deprecated Use `requestStatus` field instead.
   */
  status: RequestedMediaStatus;
  /** The url to the thumbnail image of a video. Only available if the media has been uploaded. */
  thumbnail_url?: Maybe<Scalars['String']['output']>;
  /** Unix timestamp in millis of request status update. */
  updated_at: Scalars['TimestampInMillis']['output'];
};

export type FuelCardAssociationResponse = {
  __typename?: 'FuelCardAssociationResponse';
  createdAt: Scalars['Float']['output'];
  deletedAt?: Maybe<Scalars['Float']['output']>;
  fleetId: Scalars['ID']['output'];
  fuelCardId: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  providerLicensePlate: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  updatedAt?: Maybe<Scalars['Float']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type FuelCardAssociationStatusInput = {
  fuelCardIds: Array<Scalars['ID']['input']>;
};

export type FuelCardAssociationStatusResponse = {
  __typename?: 'FuelCardAssociationStatusResponse';
  message?: Maybe<Scalars['String']['output']>;
};

export type FuelDto = {
  __typename?: 'FuelDTO';
  consumption?: Maybe<Scalars['Float']['output']>;
  /** @deprecated Use `consumption` field. */
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  price?: Maybe<Scalars['Float']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type FuelInput = {
  consumption?: InputMaybe<Scalars['Float']['input']>;
  price?: InputMaybe<Scalars['Float']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
};

export type FuelTransactionIntegrationResponse = {
  __typename?: 'FuelTransactionIntegrationResponse';
  createdAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  ignoreTransactionType: Scalars['Boolean']['output'];
};

export type FuelTransactionResponse = {
  __typename?: 'FuelTransactionResponse';
  cobliCostPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  cobliDrivenMeters?: Maybe<Scalars['Long']['output']>;
  cobliFuelConsumption?: Maybe<Scalars['Float']['output']>;
  cobliOdometer?: Maybe<Scalars['Float']['output']>;
  commodity: Scalars['String']['output'];
  costCenterDescription?: Maybe<Scalars['String']['output']>;
  costCenterId?: Maybe<Scalars['String']['output']>;
  costPerDrivenKm?: Maybe<Scalars['Float']['output']>;
  createdAt: Scalars['TimestampInMillis']['output'];
  createdBy: Scalars['String']['output'];
  creatorId?: Maybe<Scalars['ID']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedBy?: Maybe<Scalars['ID']['output']>;
  drivenMeters: Scalars['Long']['output'];
  driverName?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  merchant?: Maybe<MerchantResponse>;
  odometer?: Maybe<Scalars['Float']['output']>;
  providerCode?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['TimestampInMillis']['output'];
  unitCost: Scalars['Float']['output'];
  units: Scalars['Float']['output'];
  updatedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  updatedBy?: Maybe<Scalars['ID']['output']>;
  vehicle?: Maybe<FuelTransactionVehicleResponse>;
};

export type FuelTransactionStatsByVehicleSummaryResponse = {
  __typename?: 'FuelTransactionStatsByVehicleSummaryResponse';
  avgCostPerLiter: Scalars['Float']['output'];
  sumCobliDrivenKms: Scalars['Float']['output'];
  sumFuelLiters: Scalars['Float']['output'];
};

export type FuelTransactionSummaryResponse = {
  __typename?: 'FuelTransactionSummaryResponse';
  avgCostPerKm: Scalars['Float']['output'];
  avgFuelConsumption: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
};

export type FuelTransactionVehicleResponse = {
  __typename?: 'FuelTransactionVehicleResponse';
  cobliVehicle: VehicleDto;
  id: Scalars['ID']['output'];
  integration?: Maybe<FuelTransactionIntegrationResponse>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  refFuelConsumption?: Maybe<Scalars['Float']['output']>;
};

export type FuelTransactionsImportColumnMap = {
  fuelType?: InputMaybe<ImportColumnMapInput>;
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  merchantCity?: InputMaybe<ImportColumnMapInput>;
  merchantCnpj?: InputMaybe<ImportColumnMapInput>;
  merchantName?: InputMaybe<ImportColumnMapInput>;
  merchantState?: InputMaybe<ImportColumnMapInput>;
  odometer?: InputMaybe<ImportColumnMapInput>;
  quantityInLiters?: InputMaybe<ImportColumnMapInput>;
  totalCost?: InputMaybe<ImportColumnMapInput>;
  transactionTime?: InputMaybe<ImportColumnMapInput>;
};

export type GeofenceEvent = {
  __typename?: 'GeofenceEvent';
  eventType?: Maybe<Scalars['String']['output']>;
  geofence?: Maybe<GeofenceEventNestedGeofence>;
  id: Scalars['ID']['output'];
  lat?: Maybe<Scalars['Float']['output']>;
  lng?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
};

export type GeofenceEventNestedGeofence = {
  __typename?: 'GeofenceEventNestedGeofence';
  category?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type Geofences = {
  __typename?: 'Geofences';
  category?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
};

export type Geometry = {
  __typename?: 'Geometry';
  coordinates: Array<Maybe<Array<Maybe<Scalars['Float']['output']>>>>;
  type: Scalars['String']['output'];
};

export type GetChecklist = {
  id: Scalars['ID']['input'];
};

export type GetChecklistsNames = {
  template: Scalars['Boolean']['input'];
};

export type GetCompletedChecklists = {
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  inputFilter?: InputMaybe<Scalars['String']['input']>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  templateIdFilter?: InputMaybe<Scalars['String']['input']>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetFuelTransactionSummaryByPeriodTypeInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  groupPeriod: Scalars['String']['input'];
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsReportInput = {
  end: Scalars['TimestampInMillis']['input'];
  start: Scalars['TimestampInMillis']['input'];
  tz?: InputMaybe<Scalars['String']['input']>;
  vehicleGroupPaths?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetFuelTransactionsSummaryInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetInsightInput = {
  category?: InputMaybe<Scalars['String']['input']>;
  from: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  to: Scalars['String']['input'];
};

export type GetLatestMaintenanceInput = {
  timezone: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type GetMaintenanceHistoryInput = {
  endDate: Scalars['DateTime']['input'];
  maintenanceTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortColumn?: InputMaybe<Scalars['String']['input']>;
  sortOrder?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetMaintenancePartsInput = {
  description?: InputMaybe<Scalars['String']['input']>;
};

export type GetPagedFuelTransactionsInput = {
  endDate: Scalars['String']['input'];
  fuelTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['String']['input'];
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleSizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type GetReminderListInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  status?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetReminderStatusCountInput = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  search?: InputMaybe<Scalars['String']['input']>;
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  titleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleTypes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type GetTemplateChecklists = {
  activeFilter?: InputMaybe<Scalars['Boolean']['input']>;
  createdByFilter?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  nameFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
  vehicleGroupIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIdsFilters?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type HarshEvents = {
  __typename?: 'HarshEvents';
  acceleration: SensibilityConfiguration;
  braking: SensibilityConfiguration;
  cornering: SensibilityConfiguration;
  impact?: Maybe<SensibilityConfiguration>;
};

export type HarshEventsByDutyType = {
  __typename?: 'HarshEventsByDutyType';
  heavy: HarshEvents;
  light: HarshEvents;
  medium: HarshEvents;
};

export type HarshEventsByDutyTypeInput = {
  heavy: HarshEventsInput;
  light: HarshEventsInput;
  medium: HarshEventsInput;
};

export type HarshEventsInput = {
  acceleration: SensibilityConfigurationInput;
  braking: SensibilityConfigurationInput;
  cornering: SensibilityConfigurationInput;
  impact?: InputMaybe<SensibilityConfigurationInput>;
};

export type HomeProductivitySummary = {
  __typename?: 'HomeProductivitySummary';
  averageEngineOnTimeInMinutes: Scalars['Int']['output'];
  averageIdleOnTimeInMinutes: Scalars['Int']['output'];
  averageJourneyTimeInMinutes: Scalars['Int']['output'];
  averageStopTimeInMinutes: Scalars['Int']['output'];
};

export type HomeSpeedSummary = {
  __typename?: 'HomeSpeedSummary';
  roadEvents: AggregatedSpeedEventsSummary;
  vehicleEvents: AggregatedSpeedEventsSummary;
};

export type ICreatedUser = {
  __typename?: 'ICreatedUser';
  fullName: Scalars['String']['output'];
  id: Scalars['String']['output'];
};

export type IEnrollmentFormInfo = {
  __typename?: 'IEnrollmentFormInfo';
  invite: IInvite;
  occupations?: Maybe<Array<Maybe<IOccupation>>>;
};

export type IInvite = {
  __typename?: 'IInvite';
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
};

export type IInviteAcceptForm = {
  full_name: Scalars['String']['input'];
  occupation?: InputMaybe<Scalars['String']['input']>;
  password: Scalars['String']['input'];
};

export type IOccupation = {
  __typename?: 'IOccupation';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type ITicket = {
  associatedDealId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export enum IdentificationMethod {
  FaceIdentification = 'FACE_IDENTIFICATION',
  TripWithoutImage = 'TRIP_WITHOUT_IMAGE',
  UserConfirmation = 'USER_CONFIRMATION',
  UserEdit = 'USER_EDIT',
  WithoutIdentification = 'WITHOUT_IDENTIFICATION',
}

export type IdentificationToken = {
  __typename?: 'IdentificationToken';
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  cobli_internal_id: Scalars['String']['output'];
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  status: Scalars['String']['output'];
  token_id: Scalars['String']['output'];
  token_type: Scalars['String']['output'];
};

export type IdentificationTokenFilters = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  isLinkedToDriver?: InputMaybe<Scalars['Boolean']['input']>;
};

export type IdentificationTokenLastUsage = {
  __typename?: 'IdentificationTokenLastUsage';
  location?: Maybe<Location>;
  timestamp?: Maybe<Scalars['TimestampInMillis']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export enum IdentificationTokenStatus {
  /** @deprecated Should use string instead of graphql */
  AwaitingReturn = 'awaiting_return',
  /** @deprecated Should use string instead of graphql */
  Broken = 'broken',
  /** @deprecated Should use string instead of graphql */
  Commodate = 'commodate',
  /** @deprecated Should use string instead of graphql */
  Donated = 'donated',
  /** @deprecated Should use string instead of graphql */
  External = 'external',
  /** @deprecated Should use string instead of graphql */
  InStock = 'in_stock',
  /** @deprecated Should use string instead of graphql */
  Indebted = 'indebted',
  /** @deprecated Should use string instead of graphql */
  Lost = 'lost',
  /** @deprecated Should use string instead of graphql */
  Refunded = 'refunded',
  /** @deprecated Should use string instead of graphql */
  Testing = 'testing',
  /** @deprecated Should use string instead of graphql */
  Unknown = 'unknown',
}

export type IdentificationTokenV2 = {
  __typename?: 'IdentificationTokenV2';
  alias: Scalars['String']['output'];
  associated_to_driver_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  associated_to_fleet_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['String']['output'];
  is_external: Scalars['Boolean']['output'];
  lastUsage?: Maybe<IdentificationTokenLastUsage>;
  status: Scalars['String']['output'];
  /** @deprecated Use alias instead */
  token_alias: Scalars['String']['output'];
  /** @deprecated Use id instead */
  token_id: Scalars['String']['output'];
  /** @deprecated Use type instead */
  token_type: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ImportBatchResponse = {
  __typename?: 'ImportBatchResponse';
  count: Scalars['Long']['output'];
};

export type ImportColumnMap = {
  __typename?: 'ImportColumnMap';
  name: Scalars['String']['output'];
  position: Scalars['String']['output'];
};

export type ImportColumnMapInput = {
  name: Scalars['String']['input'];
  position: Scalars['String']['input'];
};

export type ImportErrorDto = {
  __typename?: 'ImportErrorDTO';
  field?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
};

export type ImportExpensesBatchInput = {
  categoryId: Scalars['String']['input'];
  groupPath?: InputMaybe<Scalars['String']['input']>;
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['Float']['input'];
  type: Scalars['String']['input'];
  vehicleId: Scalars['String']['input'];
};

export type ImportFuelTransactionsBatchInput = {
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchant?: InputMaybe<MerchantCreateInput>;
  odometerInKm: Scalars['Float']['input'];
  quantityInLiters: Scalars['Float']['input'];
  totalCost: Scalars['Float']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ImportMaintenanceBatchInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt: Scalars['DateTime']['input'];
  odometerInKms: Scalars['Float']['input'];
  parts: Array<ImportMaintenancePartInput>;
  types: Array<Scalars['String']['input']>;
  vehicleId: Scalars['String']['input'];
};

export type ImportMaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partName: Scalars['String']['input'];
  price: Scalars['Float']['input'];
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type ImportVehicleRowDto = {
  __typename?: 'ImportVehicleRowDTO';
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate: Scalars['String']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Int']['output']>;
};

export type Incidents = {
  __typename?: 'Incidents';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  time: Scalars['Float']['output'];
  type: Scalars['String']['output'];
};

export type InputActivity = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  destination: DestinationInput;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  duration?: InputMaybe<Scalars['TimeIntervalInMillis']['input']>;
  load_size?: InputMaybe<Scalars['Int']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_time?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  time_windows?: InputMaybe<Array<TimeWindowInput>>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type InsertUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type Insight = {
  __typename?: 'Insight';
  action?: Maybe<Scalars['String']['output']>;
  category?: Maybe<Scalars['String']['output']>;
  createdAt: Scalars['String']['output'];
  driver?: Maybe<Driver>;
  fleetId: Scalars['ID']['output'];
  group?: Maybe<Array<Maybe<VehiclesGroup>>>;
  id: Scalars['ID']['output'];
  impact?: Maybe<Scalars['String']['output']>;
  insightText?: Maybe<Scalars['String']['output']>;
  seen: Scalars['Boolean']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type InsightEvaluation = {
  __typename?: 'InsightEvaluation';
  comment?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  insight: Insight;
  spanId: Scalars['String']['output'];
  thumbDown?: Maybe<Scalars['Boolean']['output']>;
  thumbUp?: Maybe<Scalars['Boolean']['output']>;
  traceId: Scalars['String']['output'];
};

export type InsightThumbsDownInput = {
  comment?: InputMaybe<Scalars['String']['input']>;
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InsightThumbsUpInput = {
  groupPath?: InputMaybe<Scalars['String']['input']>;
  insightId: Scalars['ID']['input'];
};

export type InstallationAddressInformation = {
  __typename?: 'InstallationAddressInformation';
  addressConfirmation?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
};

export type InstallationClientInformation = {
  __typename?: 'InstallationClientInformation';
  email?: Maybe<Scalars['String']['output']>;
  installationDoneByClient?: Maybe<Scalars['Boolean']['output']>;
  installationProblem?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumber?: Maybe<Scalars['String']['output']>;
  responsibleForTrackingScheduling?: Maybe<Scalars['String']['output']>;
};

export type InstallationCoblerInformation = {
  __typename?: 'InstallationCoblerInformation';
  responsible?: Maybe<Scalars['String']['output']>;
  responsibleScheduling?: Maybe<Scalars['String']['output']>;
  responsibleToContactClient?: Maybe<Scalars['String']['output']>;
  technicalResponsible?: Maybe<Scalars['String']['output']>;
};

export type InstallationContactInformation = {
  __typename?: 'InstallationContactInformation';
  bestTimeToContact?: Maybe<Scalars['String']['output']>;
  bestWayOfContact?: Maybe<Scalars['String']['output']>;
  meansToContact?: Maybe<Scalars['String']['output']>;
  meansToContactTheResponsibleForInstallation?: Maybe<Scalars['String']['output']>;
};

export type InstallationDateInformation = {
  __typename?: 'InstallationDateInformation';
  clientFirstPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientFirstPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleDay?: Maybe<Scalars['String']['output']>;
  clientSecondPreferredScheduleHour?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
};

export type InstallationDeviceInformation = {
  __typename?: 'InstallationDeviceInformation';
  calculatedInstallDevices?: Maybe<Scalars['Int']['output']>;
  esnToInstall?: Maybe<Scalars['String']['output']>;
  esnToNotInstall?: Maybe<Scalars['String']['output']>;
  heavyOrLightVehiclesInstalledIdentifierQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledImmobilizerQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  heavyOrLightVehiclesInstalledQuantityCoblicam?: Maybe<Scalars['Int']['output']>;
  installationDevicesCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationDevicesIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  installationEsns?: Maybe<Scalars['String']['output']>;
  installationInstalledEsns?: Maybe<Scalars['String']['output']>;
  installationNotInstalledEsns?: Maybe<Scalars['String']['output']>;
  lightVehiclesInstalledBlockerQuantity?: Maybe<Scalars['Int']['output']>;
  motorcyclesOrHeavyVehiclesInstalledQuantity?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type InstallationFieldControlInformation = {
  __typename?: 'InstallationFieldControlInformation';
  fieldAssociation?: Maybe<Scalars['String']['output']>;
  fieldClass?: Maybe<Scalars['String']['output']>;
  fieldControlObservation?: Maybe<Scalars['String']['output']>;
  observationToTheTechnicalTeam?: Maybe<Scalars['String']['output']>;
  supplyInstalacaoClasse?: Maybe<Scalars['String']['output']>;
  worker?: Maybe<Scalars['String']['output']>;
};

export type InstallationInformation = {
  __typename?: 'InstallationInformation';
  addressInformation?: Maybe<InstallationAddressInformation>;
  clientInformation?: Maybe<InstallationClientInformation>;
  coblerInformation?: Maybe<InstallationCoblerInformation>;
  contactInformation?: Maybe<InstallationContactInformation>;
  dateInformation?: Maybe<InstallationDateInformation>;
  deviceInformation?: Maybe<InstallationDeviceInformation>;
  fieldControlInformation?: Maybe<InstallationFieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  installationConfirmedAt?: Maybe<Scalars['String']['output']>;
  installedDate?: Maybe<Scalars['String']['output']>;
  notResponsible?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratedAt?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<InstallationResponsibleUser>;
  scheduledDateTime?: Maybe<Scalars['String']['output']>;
  scheduledDay?: Maybe<Scalars['String']['output']>;
  vehicleInformation?: Maybe<InstallationVehicleInformation>;
};

export type InstallationResponsibleUser = {
  __typename?: 'InstallationResponsibleUser';
  createdAt?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleetIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['String']['output']>;
};

export type InstallationVehicleInformation = {
  __typename?: 'InstallationVehicleInformation';
  plack?: Maybe<Scalars['String']['output']>;
  vehicles?: Maybe<Scalars['String']['output']>;
};

export type InvalidDriverSheetRow = {
  __typename?: 'InvalidDriverSheetRow';
  data: InvalidDriverSpreadsheetRow;
  errors: Array<Scalars['String']['output']>;
  index: Scalars['Int']['output'];
};

export type InvalidDriverSpreadsheetRow = {
  __typename?: 'InvalidDriverSpreadsheetRow';
  cpf?: Maybe<Scalars['String']['output']>;
  driver_license?: Maybe<Scalars['String']['output']>;
  first_license_acquirement_date?: Maybe<Scalars['String']['output']>;
  license_category?: Maybe<Scalars['String']['output']>;
  license_expiration_date?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['String']['output']>;
  registry_id?: Maybe<Scalars['String']['output']>;
};

export type InvalidImportVehicleRowDto = {
  __typename?: 'InvalidImportVehicleRowDTO';
  data: ValidateImportVehicleRowDto;
  errors: Array<ImportErrorDto>;
};

export type Invite = {
  __typename?: 'Invite';
  creationDate: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['String']['output'];
  customPermissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  emailAddress: Scalars['String']['output'];
  fleetId: Scalars['String']['output'];
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groupsRestriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  role: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type InviteForm = {
  custom_permissions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  email_address: Scalars['String']['input'];
  groups_restriction: Array<InputMaybe<Scalars['String']['input']>>;
  role: Scalars['String']['input'];
  suggested_user_name?: InputMaybe<Scalars['String']['input']>;
};

export type InviteResponse = {
  __typename?: 'InviteResponse';
  email_address: Scalars['String']['output'];
  token: Scalars['String']['output'];
};

export type LastAssociation = {
  __typename?: 'LastAssociation';
  cobliId?: Maybe<Scalars['String']['output']>;
  deviceId?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<DriverLastAssociation>;
  fleetId: Scalars['ID']['output'];
  lastLocation?: Maybe<LastLocation>;
  vehicle?: Maybe<VehicleLastAssociation>;
};

export type LastLocation = {
  __typename?: 'LastLocation';
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  deviceId: Scalars['String']['output'];
  heading?: Maybe<Scalars['Int']['output']>;
  idleOffDurationInMillis?: Maybe<Scalars['Float']['output']>;
  idleOnDurationInMillis?: Maybe<Scalars['Float']['output']>;
  ignitionOn?: Maybe<Scalars['Boolean']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  pluggedUpdateTimestamp?: Maybe<Scalars['Float']['output']>;
  processedAt?: Maybe<Scalars['Float']['output']>;
  speed?: Maybe<Scalars['Float']['output']>;
  time?: Maybe<Scalars['Float']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type LastPath = {
  __typename?: 'LastPath';
  event_time: Scalars['TimestampInMillis']['output'];
};

export type LastPathInput = {
  deviceId: Scalars['String']['input'];
};

export enum LicenseCategory {
  A = 'A',
  Ab = 'AB',
  Ac = 'AC',
  Acc = 'ACC',
  Ad = 'AD',
  Ae = 'AE',
  B = 'B',
  C = 'C',
  D = 'D',
  E = 'E',
}

export type ListActivitiesInput = {
  activities_type?: InputMaybe<ActivityType>;
  completion_statuses?: InputMaybe<Array<ActivityCompletionStatus>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  end_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page: Scalars['Int']['input'];
  routes_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  start_in_millis?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  without_route?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ListRoutesInput = {
  driver_id?: InputMaybe<Scalars['String']['input']>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicle_id?: InputMaybe<Scalars['String']['input']>;
};

export type ListRoutesInputV2 = {
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  period: DateRange;
  size: Scalars['Int']['input'];
  sort?: InputMaybe<Sort>;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type Location = {
  __typename?: 'Location';
  lat: Scalars['Float']['output'];
  lng: Scalars['Float']['output'];
};

export type Maintenance = {
  __typename?: 'Maintenance';
  apiVersion?: Maybe<Scalars['String']['output']>;
  createdBy: Scalars['ID']['output'];
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  occurrenceAt?: Maybe<Scalars['DateTime']['output']>;
  odometerInKms?: Maybe<Scalars['Float']['output']>;
  parts?: Maybe<Array<Maybe<MaintenancePart>>>;
  recurrences?: Maybe<Array<Maybe<Recurrence>>>;
  totalPrice?: Maybe<Scalars['Float']['output']>;
  types: Array<Maybe<Scalars['String']['output']>>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  updatedBy?: Maybe<Scalars['DateTime']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type MaintenanceImportColumnMap = {
  licensePlate?: InputMaybe<ImportColumnMapInput>;
  maintenanceObservation?: InputMaybe<ImportColumnMapInput>;
  occurrenceAt?: InputMaybe<ImportColumnMapInput>;
  odometerInKms?: InputMaybe<ImportColumnMapInput>;
  partName?: InputMaybe<ImportColumnMapInput>;
  partObservation?: InputMaybe<ImportColumnMapInput>;
  quantity?: InputMaybe<ImportColumnMapInput>;
  type?: InputMaybe<ImportColumnMapInput>;
  unitCost?: InputMaybe<ImportColumnMapInput>;
};

export type MaintenancePart = {
  __typename?: 'MaintenancePart';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  part?: Maybe<Part>;
  price?: Maybe<Scalars['Float']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
};

export type MaintenancePartInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  partId: Scalars['ID']['input'];
  price?: InputMaybe<Scalars['Float']['input']>;
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

export type MaintenancePartResponse = {
  __typename?: 'MaintenancePartResponse';
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<MaintenancePart>>>;
};

export type MaintenanceReminderResponse = {
  __typename?: 'MaintenanceReminderResponse';
  count: Scalars['Int']['output'];
  rows: Array<ReminderDto>;
};

export type MaintenanceResponse = {
  __typename?: 'MaintenanceResponse';
  count: Scalars['Int']['output'];
  rows?: Maybe<Array<Maybe<Maintenance>>>;
};

export type MaintenanceStatus = {
  __typename?: 'MaintenanceStatus';
  days?: Maybe<Scalars['Int']['output']>;
  km?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type Manager = {
  __typename?: 'Manager';
  accessible_fleets?: Maybe<Array<Maybe<AcessibleFleets>>>;
  active?: Maybe<Scalars['Boolean']['output']>;
  creation_date?: Maybe<Scalars['String']['output']>;
  email?: Maybe<Scalars['String']['output']>;
  fleets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  fullname?: Maybe<Scalars['String']['output']>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  id: Scalars['ID']['output'];
  language?: Maybe<Scalars['String']['output']>;
  last_login?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  timezone?: Maybe<Scalars['Int']['output']>;
};

export type ManualOdometer = {
  __typename?: 'ManualOdometer';
  createdAt: Scalars['String']['output'];
  createdBy?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  odometerAt: Scalars['String']['output'];
  odometerInKms: Scalars['Long']['output'];
};

export type MappedDriver = {
  __typename?: 'MappedDriver';
  cpf?: Maybe<Scalars['String']['output']>;
  driver_license?: Maybe<Scalars['String']['output']>;
  first_license_acquirement_date?: Maybe<Scalars['Date']['output']>;
  license_category?: Maybe<LicenseCategory>;
  license_expiration_date?: Maybe<Scalars['Date']['output']>;
  name: Scalars['String']['output'];
  phone_number?: Maybe<Scalars['PhoneNumber']['output']>;
  registry_id?: Maybe<Scalars['String']['output']>;
};

export type Media = {
  __typename?: 'Media';
  /** AI suggested driver */
  ai_suggested_driver?: Maybe<Driver>;
  /** AI suggested driver ID */
  ai_suggested_driver_id?: Maybe<Scalars['ID']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Comments of the media */
  comments?: Maybe<Array<Maybe<MediaComment>>>;
  /** Device of the media */
  device?: Maybe<Device>;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['output'];
  /** Driver associated with the Media */
  driver?: Maybe<Driver>;
  /** DriverFaceCluster data for the media */
  driver_face_cluster?: Maybe<DriverFaceClustersMedia>;
  /** Driver identifier UUID. Available only if a driver was assigned to the device ID at video start timestamp. */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Driver name. Available only if a driver was assigned to the device ID at video start timestamp.
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Group path */
  group_path?: Maybe<Scalars['String']['output']>;
  /** Media ID */
  id: Scalars['ID']['output'];
  /** Is favorite media */
  is_favorite?: Maybe<Scalars['Boolean']['output']>;
  media_details: MediaDetails;
  /** Media status considering view count and safety review status. */
  media_status: MediaStatus;
  /** Type of media content. */
  media_type: MediaType;
  /**
   * User views count
   * @deprecated Use `mediaStatus` field instead.
   */
  media_view_count: Scalars['Int']['output'];
  /** Media safety review */
  safety_review?: Maybe<SafetyReview>;
  /** Event severity. */
  severity?: Maybe<Severity>;
  /** Detailed severity definition */
  severity_detail?: Maybe<SeverityDetail>;
  /** Video start Unix timestamp in millis. */
  timestamp: Scalars['TimestampInMillis']['output'];
  /** Driver associated before review */
  unreviewed_driver?: Maybe<Driver>;
  /** Vehicle details */
  vehicle?: Maybe<VehicleDto>;
  /** Group */
  vehicle_group?: Maybe<VehiclesGroup>;
  /** Vehicle identifier */
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type MediaComment = {
  __typename?: 'MediaComment';
  /** Content of the comment */
  content?: Maybe<Scalars['String']['output']>;
  /** Datetime of comment creation */
  created_at: Scalars['String']['output'];
  /** ID of the user that created the comment */
  created_by: Scalars['ID']['output'];
  /** User that created the comment */
  created_by_user: FleetUser;
  /** Media comment ID */
  id: Scalars['ID']['output'];
  /** Media ID associated with comment */
  media_id: Scalars['ID']['output'];
  /** Datetime of comment last update */
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type MediaDetails = EventVideo | FootageVideo;

export type MediaPage = {
  __typename?: 'MediaPage';
  content?: Maybe<Array<Maybe<Media>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export enum MediaRequestStatus {
  AmountExceeded = 'AMOUNT_EXCEEDED',
  CorruptedVideo = 'CORRUPTED_VIDEO',
  FailedRequest = 'FAILED_REQUEST',
  FinishedRequest = 'FINISHED_REQUEST',
  LmErrorFailed = 'LM_ERROR_FAILED',
  LmErrorUnavailable = 'LM_ERROR_UNAVAILABLE',
  ManualRetryRequest = 'MANUAL_RETRY_REQUEST',
  PendingRequest = 'PENDING_REQUEST',
  PeriodUnavailable = 'PERIOD_UNAVAILABLE',
  Requested = 'REQUESTED',
  RequestAcknowledged = 'REQUEST_ACKNOWLEDGED',
  RetryRequested = 'RETRY_REQUESTED',
  TimeoutRequest = 'TIMEOUT_REQUEST',
}

export type MediaRequestTrigger = {
  __typename?: 'MediaRequestTrigger';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  rule_category?: Maybe<Scalars['String']['output']>;
};

export type MediaResponse = {
  __typename?: 'MediaResponse';
  /** Safety review description generated by AI */
  ai_description?: Maybe<Scalars['String']['output']>;
  /** AI video tags */
  ai_video_tags?: Maybe<AiVideoTags>;
  /** Url expiration date */
  expiration_date?: Maybe<Scalars['Long']['output']>;
  /** Media information data */
  media_info?: Maybe<Media>;
  /** Media Url generated and signed with expiration data */
  media_url?: Maybe<Scalars['String']['output']>;
  /** Suggested occurrences by AI */
  suggested_occurrences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Videos from media */
  videos?: Maybe<Array<Maybe<VideoDto>>>;
};

export enum MediaStatus {
  Dismissed = 'DISMISSED',
  New = 'NEW',
  Relevant = 'RELEVANT',
  Watched = 'WATCHED',
}

export enum MediaType {
  EventVideo = 'EVENT_VIDEO',
  FootageVideo = 'FOOTAGE_VIDEO',
  Timelapse = 'TIMELAPSE',
}

export type MerchantCreateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['String']['input']>;
  longitude?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type MerchantImportResponse = {
  __typename?: 'MerchantImportResponse';
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantResponse = {
  __typename?: 'MerchantResponse';
  city?: Maybe<Scalars['String']['output']>;
  cnpj?: Maybe<Scalars['String']['output']>;
  lat?: Maybe<Scalars['String']['output']>;
  lng?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type MerchantUpdateInput = {
  city?: InputMaybe<Scalars['String']['input']>;
  cnpj?: InputMaybe<Scalars['String']['input']>;
  lat?: InputMaybe<Scalars['String']['input']>;
  lng?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
};

export type Mutation = {
  __typename?: 'Mutation';
  acceptInvite?: Maybe<ICreatedUser>;
  addChecklist: Checklist;
  addDriver?: Maybe<Driver>;
  addDrivers?: Maybe<Array<Maybe<Driver>>>;
  assignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to assign a driver to a cluster, a face association request will be created. */
  assignFaceCluster?: Maybe<Scalars['Boolean']['output']>;
  associateTokenToDriver?: Maybe<IdentificationTokenV2>;
  /** If the requester is authorized to change the camera configuration, it will be changed. */
  changeCameraConfiguration?: Maybe<Scalars['Boolean']['output']>;
  createActivities: Array<Activity>;
  createCheckpointManual: CreateManualOdometerResponse;
  /** Create a new fleet audio message. The message text is converted to audio using AWS Polly text-to-speech and stored in S3. */
  createFleetAudioMessage?: Maybe<FleetAudioMessage>;
  createFuelTransaction: FuelTransactionResponse;
  createMaintenanceHistory: Maintenance;
  createMaintenanceParts: Part;
  createMaintenanceReminder: Array<ReminderDto>;
  createMedia: CreateMediaResponse;
  createRoutes?: Maybe<Array<Route>>;
  createVehicle: VehicleDto;
  createVehiclesBatch: Array<VehicleDto>;
  createVehiclesGroup?: Maybe<VehiclesGroup>;
  deleteActivities: Array<Scalars['ID']['output']>;
  deleteChecklist: Checklist;
  deleteDriver?: Maybe<Driver>;
  /** Delete a playback record. Only pending and failed playbacks can be deleted (not successful ones). */
  deleteFleetAudioMessagePlayback?: Maybe<Scalars['Boolean']['output']>;
  deleteFuelCardAssociation: FuelCardAssociationStatusResponse;
  deleteFuelTransactions: Scalars['Boolean']['output'];
  deleteInvite?: Maybe<Scalars['String']['output']>;
  deleteMaintenanceHistory?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceParts?: Maybe<Scalars['Boolean']['output']>;
  deleteMaintenanceReminder?: Maybe<Scalars['Boolean']['output']>;
  deleteRoutes: Array<Maybe<Scalars['ID']['output']>>;
  deleteToken?: Maybe<Scalars['String']['output']>;
  deleteVehicleTag: Scalars['String']['output'];
  deleteVehiclesGroup?: Maybe<Scalars['ID']['output']>;
  disassociateTokenFromDriver?: Maybe<Scalars['String']['output']>;
  /** Nominates a driver for a trip. */
  driverNominateTripImage?: Maybe<Scalars['Boolean']['output']>;
  endRoute: Route;
  evaluateInsightThumbsDown?: Maybe<InsightEvaluation>;
  evaluateInsightThumbsUp?: Maybe<InsightEvaluation>;
  importDriverSpreadsheet?: Maybe<DriverSpreadsheetResult>;
  importExpenses: ImportBatchResponse;
  importFuelTransactions: ImportBatchResponse;
  importMaintenanceHistory: ImportBatchResponse;
  importSpreadsheet: Array<SpreadsheetImportResultAddress>;
  insertUserNotificationSettings?: Maybe<UserNotificationSettings>;
  /** Send an audio message to play on a specific device. Creates a playback record and attempts immediate delivery. */
  playFleetAudioMessage?: Maybe<FleetAudioMessagePlayback>;
  restoreFuelCardAssociation: FuelCardAssociationStatusResponse;
  /** Retry a failed or pending playback. Resets status to PENDING and attempts delivery again. */
  retryFleetAudioMessagePlayback?: Maybe<FleetAudioMessagePlayback>;
  sendInvites?: Maybe<SendInvitesResponse>;
  /** Updates user feedback on a labeled image obstruction. */
  sendTripImageObstructionFeedback?: Maybe<Scalars['Boolean']['output']>;
  setupUserNotificationSettings?: Maybe<Array<Maybe<UserNotificationSettings>>>;
  startRoute: Route;
  toggleChecklistActive: Checklist;
  unassignDriverToDevice?: Maybe<Scalars['Boolean']['output']>;
  updateActivity: Activity;
  /** If the requester is authorized to request the media, the faceId association will be updated. */
  updateAssociation?: Maybe<Scalars['Boolean']['output']>;
  /** If the requester is authorized to request the media, a media request will be created. */
  updateAudio?: Maybe<Scalars['Boolean']['output']>;
  updateChecklist: Checklist;
  updateContactTraining?: Maybe<Scalars['Boolean']['output']>;
  updateDeviceParameters: UpdateParameterResponse;
  updateDeviceStatusSubscription?: Maybe<Scalars['ID']['output']>;
  updateDriver?: Maybe<Driver>;
  /** Update the events configuration for the requester's fleet cameras. */
  updateFleetEventsConfiguration?: Maybe<Scalars['Boolean']['output']>;
  updateFuelCardAssociation: FuelCardAssociationStatusResponse;
  updateFuelTransaction: FuelTransactionResponse;
  updateMaintenanceHistory: Maintenance;
  updateMaintenanceParts: Part;
  updateMaintenanceReminder: ReminderDto;
  updateRouteV2: Route;
  /** If the requester is authorized to change the speed limit configuration, it will be changed. */
  updateSpeedLimitConfiguration?: Maybe<Scalars['Boolean']['output']>;
  updateUserActivationTask?: Maybe<UserActivationTask>;
  updateUserNotificationSettings?: Maybe<UserNotificationSettings>;
  updateUserTrainingMedia?: Maybe<UserTrainingMedia>;
  updateVehicle?: Maybe<VehicleDto>;
  updateVehicleImmobilizer?: Maybe<VehicleDto>;
  updateVehiclesGroup?: Maybe<VehiclesGroup>;
  validateImportVehicleSpreadsheet: ValidateImportVehicleSpreadsheetResponse;
  vehicleAssociations: Array<Activity>;
};

export type MutationAcceptInviteArgs = {
  input: IInviteAcceptForm;
  token: Scalars['String']['input'];
};

export type MutationAddChecklistArgs = {
  input?: InputMaybe<NewChecklist>;
};

export type MutationAddDriverArgs = {
  input?: InputMaybe<AddDriver>;
};

export type MutationAddDriversArgs = {
  input?: InputMaybe<Array<InputMaybe<AddDriver>>>;
};

export type MutationAssignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationAssignFaceClusterArgs = {
  input: Array<InputMaybe<DriverFaceClusterUpdate>>;
};

export type MutationAssociateTokenToDriverArgs = {
  driverId: Scalars['String']['input'];
  id: Scalars['String']['input'];
};

export type MutationChangeCameraConfigurationArgs = {
  input: Array<InputMaybe<CameraConfigurationUpdateInput>>;
};

export type MutationCreateActivitiesArgs = {
  input: Array<InputActivity>;
};

export type MutationCreateCheckpointManualArgs = {
  input: CreateCheckpointManualInput;
};

export type MutationCreateFleetAudioMessageArgs = {
  input: CreateFleetAudioMessageInput;
};

export type MutationCreateFuelTransactionArgs = {
  input: CreateFuelTransactionInput;
};

export type MutationCreateMaintenanceHistoryArgs = {
  input: CreateMaintenanceHistoryInput;
};

export type MutationCreateMaintenancePartsArgs = {
  input: CreateMaintenancePartsInput;
};

export type MutationCreateMaintenanceReminderArgs = {
  input: CreateReminderInput;
};

export type MutationCreateMediaArgs = {
  input: CreateMediaRequest;
};

export type MutationCreateRoutesArgs = {
  input?: InputMaybe<RoutingSettings>;
};

export type MutationCreateVehicleArgs = {
  input: CreateVehicleInput;
};

export type MutationCreateVehiclesBatchArgs = {
  input: CreateVehiclesBatchInput;
};

export type MutationCreateVehiclesGroupArgs = {
  input: VehiclesGroupInput;
};

export type MutationDeleteActivitiesArgs = {
  input: DeleteActivitiesIds;
};

export type MutationDeleteChecklistArgs = {
  input?: InputMaybe<DeleteChecklist>;
};

export type MutationDeleteDriverArgs = {
  input?: InputMaybe<DeleteDriver>;
};

export type MutationDeleteFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationDeleteFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationDeleteFuelTransactionsArgs = {
  input: DeleteFuelTransactionsInput;
};

export type MutationDeleteInviteArgs = {
  token: Scalars['String']['input'];
};

export type MutationDeleteMaintenanceHistoryArgs = {
  input: DeleteMaintenanceHistoryInput;
};

export type MutationDeleteMaintenancePartsArgs = {
  input: DeleteMaintenancePartsInput;
};

export type MutationDeleteMaintenanceReminderArgs = {
  input: DeleteMaintenanceReminderInput;
};

export type MutationDeleteRoutesArgs = {
  input?: InputMaybe<DeleteRoutesInput>;
};

export type MutationDeleteTokenArgs = {
  id: Scalars['String']['input'];
};

export type MutationDeleteVehicleTagArgs = {
  name: Scalars['String']['input'];
};

export type MutationDeleteVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
};

export type MutationDisassociateTokenFromDriverArgs = {
  id: Scalars['String']['input'];
};

export type MutationDriverNominateTripImageArgs = {
  input?: InputMaybe<Array<InputMaybe<DriverNominateTripImageInput>>>;
};

export type MutationEndRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationEvaluateInsightThumbsDownArgs = {
  input: InsightThumbsDownInput;
};

export type MutationEvaluateInsightThumbsUpArgs = {
  input: InsightThumbsUpInput;
};

export type MutationImportDriverSpreadsheetArgs = {
  input?: InputMaybe<Array<InputMaybe<DriverSpreadsheetRow>>>;
};

export type MutationImportExpensesArgs = {
  input: Array<ImportExpensesBatchInput>;
};

export type MutationImportFuelTransactionsArgs = {
  input: Array<ImportFuelTransactionsBatchInput>;
};

export type MutationImportMaintenanceHistoryArgs = {
  input: Array<ImportMaintenanceBatchInput>;
};

export type MutationImportSpreadsheetArgs = {
  input: Array<SpreadsheetRow>;
};

export type MutationInsertUserNotificationSettingsArgs = {
  input?: InputMaybe<InsertUserNotificationSettings>;
};

export type MutationPlayFleetAudioMessageArgs = {
  audioMessageId: Scalars['ID']['input'];
  input: PlayFleetAudioMessageInput;
};

export type MutationRestoreFuelCardAssociationArgs = {
  input: FuelCardAssociationStatusInput;
};

export type MutationRetryFleetAudioMessagePlaybackArgs = {
  audioMessageId: Scalars['ID']['input'];
  playbackId: Scalars['ID']['input'];
};

export type MutationSendInvitesArgs = {
  input?: InputMaybe<Array<InputMaybe<InviteForm>>>;
};

export type MutationSendTripImageObstructionFeedbackArgs = {
  input?: InputMaybe<SendImageObstructionFeedback>;
};

export type MutationSetupUserNotificationSettingsArgs = {
  input?: InputMaybe<Array<InputMaybe<InsertUserNotificationSettings>>>;
};

export type MutationStartRouteArgs = {
  input?: InputMaybe<RouteStartOrEndInput>;
};

export type MutationToggleChecklistActiveArgs = {
  input?: InputMaybe<ToggleChecklistActive>;
};

export type MutationUnassignDriverToDeviceArgs = {
  input: DriverAssignmentInput;
};

export type MutationUpdateActivityArgs = {
  input: ActivityUpdate;
};

export type MutationUpdateAssociationArgs = {
  input: AssociationConfigInput;
};

export type MutationUpdateAudioArgs = {
  input: Array<InputMaybe<UpdateAudioRequest>>;
};

export type MutationUpdateChecklistArgs = {
  input?: InputMaybe<UpdateChecklist>;
};

export type MutationUpdateContactTrainingArgs = {
  input: UpdateContactTrainingInfoInput;
};

export type MutationUpdateDeviceParametersArgs = {
  input: UpdateDeviceParameter;
};

export type MutationUpdateDeviceStatusSubscriptionArgs = {
  input?: InputMaybe<DeviceStatusSubscriptionInput>;
};

export type MutationUpdateDriverArgs = {
  input?: InputMaybe<UpdateDriver>;
};

export type MutationUpdateFleetEventsConfigurationArgs = {
  input: UpdateEventsConfigurationInput;
};

export type MutationUpdateFuelCardAssociationArgs = {
  input: UpdateFuelCardAssociationInput;
};

export type MutationUpdateFuelTransactionArgs = {
  input: UpdateFuelTransactionInput;
};

export type MutationUpdateMaintenanceHistoryArgs = {
  input: UpdateMaintenanceHistoryInput;
};

export type MutationUpdateMaintenancePartsArgs = {
  input: UpdateMaintenancePartsInput;
};

export type MutationUpdateMaintenanceReminderArgs = {
  input: UpdateReminderInput;
};

export type MutationUpdateRouteV2Args = {
  input?: InputMaybe<RouteUpdate>;
};

export type MutationUpdateSpeedLimitConfigurationArgs = {
  input?: InputMaybe<SpeedLimitUpdateInput>;
};

export type MutationUpdateUserActivationTaskArgs = {
  input: UserActivationTaskInput;
};

export type MutationUpdateUserNotificationSettingsArgs = {
  input?: InputMaybe<UpdateUserNotificationSettings>;
};

export type MutationUpdateUserTrainingMediaArgs = {
  input: UpdateUserTrainingMediaInput;
};

export type MutationUpdateVehicleArgs = {
  id: Scalars['ID']['input'];
  input: UpdateVehicleInput;
};

export type MutationUpdateVehicleImmobilizerArgs = {
  input: UpdateVehicleImmobilizerInput;
};

export type MutationUpdateVehiclesGroupArgs = {
  id: Scalars['ID']['input'];
  input: VehiclesGroupInput;
};

export type MutationValidateImportVehicleSpreadsheetArgs = {
  input: ValidateImportVehicleSpreadsheetInput;
};

export type MutationVehicleAssociationsArgs = {
  input: Array<ActivityVehicleAssociationInput>;
};

export type NewChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template: Scalars['Boolean']['input'];
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type NewChecklistContext = {
  address?: InputMaybe<Scalars['String']['input']>;
  app_version: Scalars['String']['input'];
  vehicle?: InputMaybe<NewChecklistVehicle>;
};

export type NewChecklistField = {
  content: Scalars['String']['input'];
  required: Scalars['Boolean']['input'];
  should_request_photos?: InputMaybe<Scalars['Boolean']['input']>;
  title: Scalars['String']['input'];
  type: FieldType;
};

export type NewChecklistVehicle = {
  brand?: InputMaybe<Scalars['String']['input']>;
  device_id: Scalars['String']['input'];
  group_id?: InputMaybe<Scalars['String']['input']>;
  license_plate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export enum NominationOperation {
  Confirm = 'CONFIRM',
  Edit = 'EDIT',
}

export type OldProofOfConclusion = {
  __typename?: 'OldProofOfConclusion';
  activity_id?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  alias?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completed_at: Scalars['TimestampInMillis']['output'];
  fleet_id: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  img_urls: Array<Scalars['String']['output']>;
  license_plate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  saved_at: Scalars['TimestampInMillis']['output'];
  user_id: Scalars['ID']['output'];
  user_name: Scalars['String']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type OperationSummary = {
  __typename?: 'OperationSummary';
  activities: ActivitiesSummary;
  routes: RoutesSummary;
};

export type OperationSummaryInput = {
  activity_route_relation?: InputMaybe<ActivityRouteRelation>;
  devices_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  drivers_ids?: InputMaybe<Array<Scalars['String']['input']>>;
  period: DateRange;
  text_filter?: InputMaybe<Scalars['String']['input']>;
  vehicles_ids?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type OptionContent = {
  __typename?: 'OptionContent';
  checked?: Maybe<Scalars['Boolean']['output']>;
  id: Scalars['Int']['output'];
  label: Scalars['String']['output'];
};

export enum Order {
  Asc = 'asc',
  Desc = 'desc',
}

export type PageDriverFaceClustersInfo = {
  __typename?: 'PageDriverFaceClustersInfo';
  content?: Maybe<Array<Maybe<DriverFaceClustersInfo>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageDriverFaceClustersSuggestion = {
  __typename?: 'PageDriverFaceClustersSuggestion';
  content?: Maybe<Array<Maybe<DriverFaceClustersSuggestion>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageImageTrip = {
  __typename?: 'PageImageTrip';
  content?: Maybe<Array<Maybe<TripImage>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageTrip = {
  __typename?: 'PageTrip';
  content?: Maybe<Array<Maybe<Trip>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type PageableObject = {
  __typename?: 'PageableObject';
  offset?: Maybe<Scalars['Int']['output']>;
  page_number?: Maybe<Scalars['Int']['output']>;
  page_size?: Maybe<Scalars['Int']['output']>;
  paged?: Maybe<Scalars['Boolean']['output']>;
  sort?: Maybe<SortType>;
  unpaged?: Maybe<Scalars['Boolean']['output']>;
};

export type PagedFuelTransaction = {
  __typename?: 'PagedFuelTransaction';
  cobliDrivenKms: Scalars['Float']['output'];
  costPerLiter: Scalars['Float']['output'];
  createdBy: Scalars['String']['output'];
  fuelLiters: Scalars['Float']['output'];
  fuelType: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  totalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  transactionCode?: Maybe<Scalars['String']['output']>;
  transactionTime: Scalars['TimestampInMillis']['output'];
  vehicle: PagedVehicleResponse;
};

export type PagedFuelTransactionStatsByVehicle = {
  __typename?: 'PagedFuelTransactionStatsByVehicle';
  avgCostPerKm?: Maybe<Scalars['Float']['output']>;
  avgCostPerLiter: Scalars['Float']['output'];
  consumptionAvg?: Maybe<Scalars['Float']['output']>;
  consumptionGoal?: Maybe<Scalars['Float']['output']>;
  fuelType: Scalars['String']['output'];
  sumCobliDrivenKms?: Maybe<Scalars['Float']['output']>;
  sumFuelLiters: Scalars['Float']['output'];
  sumTotalCost: Scalars['Float']['output'];
  totalCount: Scalars['Int']['output'];
  vehicleGroup?: Maybe<Scalars['String']['output']>;
  vehicleGroupName?: Maybe<Scalars['String']['output']>;
  vehicleId: Scalars['ID']['output'];
  vehicleLicensePlate: Scalars['String']['output'];
  vehicleModel?: Maybe<Scalars['String']['output']>;
};

export type PagedFuelTransactionStatsByVehicleResponse = {
  __typename?: 'PagedFuelTransactionStatsByVehicleResponse';
  content: Array<PagedFuelTransactionStatsByVehicle>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedFuelTransactionsResponse = {
  __typename?: 'PagedFuelTransactionsResponse';
  content: Array<PagedFuelTransaction>;
  number: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type PagedVehicleResponse = {
  __typename?: 'PagedVehicleResponse';
  group?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  licensePlate: Scalars['String']['output'];
  model?: Maybe<Scalars['String']['output']>;
};

export type PaginatedActivities = {
  __typename?: 'PaginatedActivities';
  content: Array<Maybe<Activity>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedChecklists = {
  __typename?: 'PaginatedChecklists';
  content: Array<Maybe<Checklist>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedRoutes = {
  __typename?: 'PaginatedRoutes';
  content: Array<Maybe<Route>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedUserAlerts = {
  __typename?: 'PaginatedUserAlerts';
  content: Array<Maybe<UserAlert>>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  number_of_elements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  total_elements: Scalars['Int']['output'];
  total_pages: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1 = {
  __typename?: 'PaginatedVehiclesV1';
  content: Array<VehicleV1>;
  totalElements: Scalars['Int']['output'];
};

export type PaginatedVehiclesV1Input = {
  groupIds?: InputMaybe<Array<Scalars['String']['input']>>;
  page: Scalars['Int']['input'];
  size: Scalars['Int']['input'];
};

export type Parameter = {
  __typename?: 'Parameter';
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  name: Scalars['String']['output'];
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  value: Scalars['String']['output'];
};

export type ParameterInput = {
  name: Scalars['String']['input'];
  value: Scalars['String']['input'];
};

export type Part = {
  __typename?: 'Part';
  description?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
};

export type Path = {
  __typename?: 'Path';
  associationSource?: Maybe<Scalars['String']['output']>;
  driver?: Maybe<VehicleDriverDto>;
  endLatitude?: Maybe<Scalars['Float']['output']>;
  endLongitude?: Maybe<Scalars['Float']['output']>;
  endTime: Scalars['Float']['output'];
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
  startLatitude?: Maybe<Scalars['Float']['output']>;
  startLongitude?: Maybe<Scalars['Float']['output']>;
  startTime: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
};

export type PathGeojson = {
  __typename?: 'PathGeojson';
  geometry: Geometry;
  properties: Properties;
  type: Scalars['String']['output'];
};

export type PlannedVsExecutedDurationTimeInMillis = {
  __typename?: 'PlannedVsExecutedDurationTimeInMillis';
  executed?: Maybe<Scalars['Long']['output']>;
  planned?: Maybe<Scalars['Long']['output']>;
};

export type PlannedVsExecutedInt = {
  __typename?: 'PlannedVsExecutedInt';
  executed?: Maybe<Scalars['Int']['output']>;
  planned?: Maybe<Scalars['Int']['output']>;
};

export type PlannedVsExecutedTimestampInMillis = {
  __typename?: 'PlannedVsExecutedTimestampInMillis';
  executed?: Maybe<Scalars['TimestampInMillis']['output']>;
  planned: Scalars['TimestampInMillis']['output'];
};

export type PlayFleetAudioMessageInput = {
  /** If true, auto-cancel the audio playback if not successfully sent within 1 hour. */
  cancelIfTimeout?: InputMaybe<Scalars['Boolean']['input']>;
  /** Device identifier (10-15 digits). */
  deviceId: Scalars['String']['input'];
  /** Optional driver ID associated with this playback. */
  driverId?: InputMaybe<Scalars['ID']['input']>;
  /** Optional driver name associated with this playback. */
  driverName?: InputMaybe<Scalars['String']['input']>;
  /** The vehicle ID on which to play the audio message. */
  vehicleId: Scalars['ID']['input'];
};

export enum PlaybackStatus {
  /** Playback was cancelled. */
  Cancelled = 'CANCELLED',
  /** Playback delivery failed. */
  Error = 'ERROR',
  /** Playback is pending delivery to the device. */
  Pending = 'PENDING',
  /** Playback was successfully delivered and played on the device. */
  Success = 'SUCCESS',
}

export type Product = {
  __typename?: 'Product';
  id: Scalars['String']['output'];
  name: Scalars['String']['output'];
};

export type ProofOfConclusion = {
  __typename?: 'ProofOfConclusion';
  activityId?: Maybe<Scalars['ID']['output']>;
  address?: Maybe<Scalars['String']['output']>;
  client?: Maybe<Scalars['String']['output']>;
  completedAt: Scalars['TimestampInMillis']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  imgUrls: Array<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  savedAt: Scalars['TimestampInMillis']['output'];
  userId: Scalars['ID']['output'];
  userName: Scalars['String']['output'];
  vehicle?: Maybe<VehicleDto>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
};

export enum PropagationType {
  AllRoutes = 'ALL_ROUTES',
  OnlyThisRoute = 'ONLY_THIS_ROUTE',
}

export type Properties = {
  __typename?: 'Properties';
  jumpsPeriods?: Maybe<Array<Array<Scalars['Float']['output']>>>;
  timestamps: Array<Maybe<Scalars['Float']['output']>>;
};

export type Query = {
  __typename?: 'Query';
  activationTasks: Array<ActivationTask>;
  activities: PaginatedActivities;
  activity: Activity;
  activitySummary: ActivitiesSummary;
  alert: PaginatedUserAlerts;
  /** Get association status of the requester's fleet cameras. */
  association?: Maybe<FleetAutoAssociationSettings>;
  /** Get audio coaching status of the requester's fleet cameras. */
  audio?: Maybe<AudioCoachingDevicesInfoPage>;
  avgFuelConsumptionAndCostPerKm: Array<AvgFuelConsumptionAndCostPerKmResponse>;
  billets?: Maybe<Array<Maybe<Billet>>>;
  /** Get audio coaching status of the requester's fleet cameras. */
  cameraConfiguration?: Maybe<CameraConfigurationInfoPage>;
  categories?: Maybe<Array<Maybe<Category>>>;
  checklist: Checklist;
  checklistsNames: ChecklistsNames;
  coachingFeedback?: Maybe<CoachingFeedbackPage>;
  coachingFeedbackDetails?: Maybe<CoachingFeedback>;
  companyOnboardingStatus?: Maybe<FleetCompanyOnboardingStatus>;
  completedChecklists: ChecklistsPage;
  contracts?: Maybe<FleetCompanyContracts>;
  customDashboard: CustomDashboard;
  customDashboards: Array<CustomDashboard>;
  deviceConfiguration: DeviceConfiguration;
  deviceStatusSubscription: DeviceStatusSubscription;
  devices: Array<Device>;
  devolutionTicketsByDeviceId: Tickets;
  driverById: Driver;
  /** Get driver face clusters of the requester's fleet cameras. */
  driverFaceClustersInfo?: Maybe<PageDriverFaceClustersInfo>;
  driverFaceClustersSuggestions?: Maybe<PageDriverFaceClustersSuggestion>;
  driverSpeedRow?: Maybe<Array<DriverSpeedRow>>;
  drivers: Array<Maybe<Driver>>;
  driversById: Array<Maybe<Driver>>;
  /** Get a summary of media counts grouped by severity levels */
  eventsSeveritiesSummary?: Maybe<SeveritiesSummary>;
  expenses: ExpensePaginatedResponse;
  fleet?: Maybe<Fleet>;
  /**
   * Get playback history for a vehicle with pagination support.
   * Results are ordered by creation date in descending order by default (newest first).
   */
  fleetAudioMessagePlaybacks?: Maybe<FleetAudioMessagePlaybackPage>;
  fleetEventsConfiguration?: Maybe<FleetEventsConfiguration>;
  /** Get fleet products */
  fleetProducts?: Maybe<FleetProducts>;
  /** Returns the users of the fleet */
  fleetUsers?: Maybe<Array<Maybe<FleetUser>>>;
  fleetVehicleGroups?: Maybe<Array<Maybe<FleetVehicleGroups>>>;
  fuelCardAssociations: Array<FuelCardAssociationResponse>;
  fuelTransactionById: FuelTransactionResponse;
  fuelTransactionStatsByVehicleSummary: FuelTransactionStatsByVehicleSummaryResponse;
  fuelTransactionsSummary: FuelTransactionSummaryResponse;
  /**
   * Get the public S3 URL for an audio file by playback ID.
   * The URL is valid for download and does not require authentication.
   */
  getAudioFile: AudioFileResponse;
  /** Check if fleet has camera */
  hasCameraFlag?: Maybe<Scalars['Boolean']['output']>;
  /** Check if fleet has camera (cached 1d) */
  hasCameraFlagCached?: Maybe<Scalars['Boolean']['output']>;
  /** Check if fleet has redecan */
  hasRedeCan?: Maybe<Scalars['Boolean']['output']>;
  homeProductivitySummary?: Maybe<HomeProductivitySummary>;
  homeSpeedSummary?: Maybe<HomeSpeedSummary>;
  homeSummaryDevices: Scalars['Int']['output'];
  homeSummaryGeofences: Scalars['Int']['output'];
  homeSummaryVehicles: Scalars['Int']['output'];
  insights?: Maybe<Array<Maybe<Insight>>>;
  inviteInfo?: Maybe<IEnrollmentFormInfo>;
  lastAssociation?: Maybe<LastAssociation>;
  lastPath?: Maybe<LastPath>;
  latestMaintenanceByVehicle?: Maybe<Maintenance>;
  maintenanceHistory: MaintenanceResponse;
  maintenanceParts: MaintenancePartResponse;
  /** Get media events and footages of the requester's fleet. */
  media?: Maybe<MediaPage>;
  /** Daily recommendations of relevant medias. */
  mediaDailyRecommendations?: Maybe<MediaPage>;
  /** Used to view a media. If the requester is authorized to watch the media, it will return a generated signed media URL and its expiration date. */
  mediaView?: Maybe<MediaResponse>;
  operationSummary: OperationSummary;
  orderById?: Maybe<CrmOrder>;
  orders: Array<Maybe<CrmOrder>>;
  pagedFuelTransactionStatsByVehicle: PagedFuelTransactionStatsByVehicleResponse;
  pagedFuelTransactions: PagedFuelTransactionsResponse;
  paginatedVehiclesV1: PaginatedVehiclesV1;
  paths?: Maybe<Array<Maybe<Path>>>;
  pendingInvites?: Maybe<Array<Maybe<Invite>>>;
  proofsOfConclusion: Array<ProofOfConclusion>;
  reminderList: MaintenanceReminderResponse;
  reminderStatusSummary: ReminderStatusCount;
  reminderTitles: Array<ReminderTitle>;
  riskEvents: Array<RiskEvent>;
  route: Route;
  routes: PaginatedRoutes;
  routesReport: Array<RouteReport>;
  routesV2: PaginatedRoutes;
  safetyRankingParams: SafetyRankingParams;
  safetyRankingProductType: SafetyRankingProductType;
  safetyRankingProductivity: SafetyRankingProductivity;
  safetyRankingScores: SafetyRankingScores;
  /** Gets the Safety Review historic records */
  safetyReviewHistory?: Maybe<SafetyReviewHistoryPage>;
  schedulingHolidays: Array<Scalars['String']['output']>;
  settings: Array<Maybe<UserNotificationSettings>>;
  sumTotalCostByFuelType: Array<SumTotalCostByFuelTypeResponse>;
  suppliers?: Maybe<Array<Maybe<Supplier>>>;
  templateChecklists: ChecklistsPage;
  tokens?: Maybe<Array<IdentificationToken>>;
  tokensV2?: Maybe<Array<IdentificationTokenV2>>;
  tracking?: Maybe<Tracking>;
  /** Returns all the training videos. */
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
  /** Returns all the training videos aggregated by category. */
  trainingVideosByCategory?: Maybe<Array<Maybe<TrainingVideos>>>;
  /** Get camera trips from a given device ID. */
  trip?: Maybe<PageTrip>;
  /** Get trip image history of the requester's fleet */
  tripImage?: Maybe<PageImageTrip>;
  /** Get camera trip images from a single trip. */
  tripImagesDetails?: Maybe<TripImage>;
  tripsByVehicle?: Maybe<PageTrip>;
  userActivationTasks: Array<UserActivationTask>;
  /** Returns the user attributes for the given user id. */
  userAttributes?: Maybe<UserAttributes>;
  /** Returns the user default roles for the given user id. */
  userDefaultRoles?: Maybe<Array<Maybe<UserDefaultRoles>>>;
  /** Returns the user fleets for the given user id. */
  userFleets?: Maybe<Array<Maybe<UserFleets>>>;
  /** Returns the user preferences for the given user id. */
  userPreferences?: Maybe<UserPreferences>;
  /** Returns user metadata for training media */
  userTrainingMedia?: Maybe<Array<Maybe<UserTrainingMedia>>>;
  validateExpensesImport: ValidateExpensesImportResponse;
  validateFuelTransactionsImport: ValidateFuelTransactionsImportResponse;
  validateMaintenanceImport: ValidateMaintenanceImportResponse;
  vehicle?: Maybe<VehicleDto>;
  vehicleDeviceAssociationReportByDevice: VehicleDeviceAssociationInfoResponse;
  vehicleDeviceAssociationReportByVehicle: VehicleDeviceAssociationInfoResponse;
  vehicleDriverAuthorizations?: Maybe<VehicleDriverAuthorization>;
  vehicleExpenses: VehicleExpensesPaginatedResponse;
  vehicleGroups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  vehicleModels: Array<Branding>;
  vehiclePastAssociations?: Maybe<Array<Maybe<VehiclePastAssociationDto>>>;
  vehicleSuggestionsBatch: BatchSuggestionsResponse;
  vehicleTags?: Maybe<Array<VehicleTag>>;
  /** Get images by vehicle and an image timestamp */
  vehicleTimestampImagesDetails?: Maybe<VehicleImages>;
  vehicleTracking?: Maybe<Tracking>;
  /** Returns trackings of route steps (trip/stop) that intersects a segment */
  vehicleTrackingSegment?: Maybe<VehicleTrackingSegmentType>;
  vehicleTripDistance: VehicleTripDistanceResponse;
  vehicles?: Maybe<Array<Maybe<VehicleDto>>>;
  wifiSettings?: Maybe<AccessPoints>;
};

export type QueryActivationTasksArgs = {
  input?: InputMaybe<ActivationTaskInput>;
};

export type QueryActivitiesArgs = {
  input: ListActivitiesInput;
};

export type QueryActivityArgs = {
  input: Scalars['ID']['input'];
};

export type QueryActivitySummaryArgs = {
  input: ActivitiesSummaryInput;
};

export type QueryAlertArgs = {
  filters?: InputMaybe<Filters>;
  page?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Sort>;
};

export type QueryAudioArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryAvgFuelConsumptionAndCostPerKmArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryBilletsArgs = {
  companyId: Scalars['ID']['input'];
  status?: InputMaybe<Scalars['String']['input']>;
};

export type QueryCameraConfigurationArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryChecklistArgs = {
  input?: InputMaybe<GetChecklist>;
};

export type QueryChecklistsNamesArgs = {
  input?: InputMaybe<GetChecklistsNames>;
};

export type QueryCoachingFeedbackArgs = {
  input?: InputMaybe<CoachingFeedbackInput>;
};

export type QueryCoachingFeedbackDetailsArgs = {
  id: Scalars['ID']['input'];
};

export type QueryCompanyOnboardingStatusArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCompletedChecklistsArgs = {
  input?: InputMaybe<GetCompletedChecklists>;
};

export type QueryContractsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryCustomDashboardArgs = {
  input: Scalars['String']['input'];
};

export type QueryDeviceConfigurationArgs = {
  input: Scalars['String']['input'];
};

export type QueryDevicesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDevolutionTicketsByDeviceIdArgs = {
  cobliId?: InputMaybe<Scalars['String']['input']>;
  deviceId?: InputMaybe<Scalars['String']['input']>;
};

export type QueryDriverByIdArgs = {
  input?: InputMaybe<WantedDriverId>;
};

export type QueryDriverFaceClustersInfoArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  hasBeenNominated?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  withoutSampleImageUrls?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryDriverFaceClustersSuggestionsArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryDriverSpeedRowArgs = {
  input: DriverSpeedRowInput;
};

export type QueryDriversByIdArgs = {
  input?: InputMaybe<WantedDrivers>;
};

export type QueryEventsSeveritiesSummaryArgs = {
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryExpensesArgs = {
  input: ExpensesListInput;
};

export type QueryFleetArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetAudioMessagePlaybacksArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryFleetUsersArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFleetVehicleGroupsArgs = {
  fleetId: Scalars['String']['input'];
};

export type QueryFuelCardAssociationsArgs = {
  input?: InputMaybe<Scalars['String']['input']>;
};

export type QueryFuelTransactionByIdArgs = {
  input: Scalars['ID']['input'];
};

export type QueryFuelTransactionStatsByVehicleSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryFuelTransactionsSummaryArgs = {
  input: GetFuelTransactionsSummaryInput;
};

export type QueryGetAudioFileArgs = {
  playbackId: Scalars['ID']['input'];
};

export type QueryHomeProductivitySummaryArgs = {
  end_date: Scalars['String']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  start_date: Scalars['String']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSpeedSummaryArgs = {
  begin: Scalars['Float']['input'];
  end: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  interval_in_days: Scalars['Int']['input'];
  tz: Scalars['String']['input'];
};

export type QueryHomeSummaryVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryInsightsArgs = {
  input: GetInsightInput;
};

export type QueryInviteInfoArgs = {
  token: Scalars['String']['input'];
};

export type QueryLastAssociationArgs = {
  deviceId: Scalars['String']['input'];
};

export type QueryLastPathArgs = {
  input: LastPathInput;
};

export type QueryLatestMaintenanceByVehicleArgs = {
  input: GetLatestMaintenanceInput;
};

export type QueryMaintenanceHistoryArgs = {
  input: GetMaintenanceHistoryInput;
};

export type QueryMaintenancePartsArgs = {
  input?: InputMaybe<GetMaintenancePartsInput>;
};

export type QueryMediaArgs = {
  aiVideoTags?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  createdBy?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  descriptionTextQuery?: InputMaybe<Scalars['String']['input']>;
  deviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  driverFaceClusterIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  eventTriggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  footageStatusesToCount?: InputMaybe<Array<InputMaybe<RequestedMediaStatus>>>;
  fromCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  isFavorite?: InputMaybe<Scalars['Boolean']['input']>;
  isRequestedByTrigger?: InputMaybe<Scalars['Boolean']['input']>;
  mediaStatus?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  mediaTypes?: InputMaybe<Array<InputMaybe<MediaType>>>;
  page?: InputMaybe<Scalars['Int']['input']>;
  requestStatus?: InputMaybe<Array<InputMaybe<MediaRequestStatus>>>;
  safetyOccurrenceIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  severities?: InputMaybe<Array<InputMaybe<Severity>>>;
  severitiesToCount?: InputMaybe<Array<InputMaybe<Severity>>>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  sortList?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  suggestedOccurrences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toCreatedAtTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  triggerIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaDailyRecommendationsArgs = {
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryMediaViewArgs = {
  mediaId?: InputMaybe<Scalars['ID']['input']>;
  shouldGenerateDescription?: InputMaybe<Scalars['Boolean']['input']>;
};

export type QueryOperationSummaryArgs = {
  input: OperationSummaryInput;
};

export type QueryOrderByIdArgs = {
  id: Scalars['ID']['input'];
};

export type QueryPagedFuelTransactionStatsByVehicleArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPagedFuelTransactionsArgs = {
  input: GetPagedFuelTransactionsInput;
};

export type QueryPaginatedVehiclesV1Args = {
  input: PaginatedVehiclesV1Input;
};

export type QueryPathsArgs = {
  associationMethods?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  endTime: Scalars['Float']['input'];
  startTime: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryProofsOfConclusionArgs = {
  activityId?: InputMaybe<Scalars['ID']['input']>;
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  period?: InputMaybe<DateRange>;
};

export type QueryReminderListArgs = {
  input: GetReminderListInput;
};

export type QueryReminderStatusSummaryArgs = {
  input: GetReminderStatusCountInput;
};

export type QueryRiskEventsArgs = {
  input: RiskEventsInput;
};

export type QueryRouteArgs = {
  input: Scalars['ID']['input'];
};

export type QueryRoutesArgs = {
  input?: InputMaybe<ListRoutesInput>;
};

export type QueryRoutesReportArgs = {
  input: DateRange;
};

export type QueryRoutesV2Args = {
  input?: InputMaybe<ListRoutesInputV2>;
};

export type QuerySafetyRankingParamsArgs = {
  input: SafetyRankingParamsInput;
};

export type QuerySafetyRankingProductivityArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyRankingScoresArgs = {
  input: SafetyRankingInput;
};

export type QuerySafetyReviewHistoryArgs = {
  mediaId: Scalars['ID']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QuerySumTotalCostByFuelTypeArgs = {
  input: GetFuelTransactionSummaryByPeriodTypeInput;
};

export type QueryTemplateChecklistsArgs = {
  input?: InputMaybe<GetTemplateChecklists>;
};

export type QueryTokensArgs = {
  input?: InputMaybe<Scalars['ID']['input']>;
};

export type QueryTokensV2Args = {
  input?: InputMaybe<IdentificationTokenFilters>;
};

export type QueryTrackingArgs = {
  input?: InputMaybe<TrackingInput>;
};

export type QueryTripArgs = {
  deviceId: Scalars['String']['input'];
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
};

export type QueryTripImageArgs = {
  driverIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
  driverVisibilities?: InputMaybe<Array<InputMaybe<DriverVisibility>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  identificationMethod?: InputMaybe<Array<InputMaybe<IdentificationMethod>>>;
  isObstructed?: InputMaybe<Scalars['Boolean']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['ID']['input']>>>;
};

export type QueryTripImagesDetailsArgs = {
  tripId: Scalars['String']['input'];
};

export type QueryTripsByVehicleArgs = {
  footageAvailabilityStatus?: InputMaybe<Array<InputMaybe<Scalars['Boolean']['input']>>>;
  fromTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  page?: InputMaybe<Scalars['Int']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  toTimestamp?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  vehicleId: Scalars['ID']['input'];
};

export type QueryUserAttributesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserDefaultRolesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserFleetsArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryUserPreferencesArgs = {
  input?: InputMaybe<UserInput>;
};

export type QueryValidateExpensesImportArgs = {
  input: ValidateExpensesImportInput;
};

export type QueryValidateFuelTransactionsImportArgs = {
  input: ValidateFuelTransactionsImportInput;
};

export type QueryValidateMaintenanceImportArgs = {
  input: ValidateMaintenanceImportInput;
};

export type QueryVehicleArgs = {
  id: Scalars['ID']['input'];
};

export type QueryVehicleDeviceAssociationReportByDeviceArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDeviceAssociationReportByVehicleArgs = {
  input: VehicleDeviceAssociationInfoInput;
};

export type QueryVehicleDriverAuthorizationsArgs = {
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleExpensesArgs = {
  input: VehiclesExpensesInput;
};

export type QueryVehicleGroupsArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type QueryVehiclePastAssociationsArgs = {
  referenceTimestamp: Scalars['String']['input'];
  vehicleId: Scalars['ID']['input'];
};

export type QueryVehicleSuggestionsBatchArgs = {
  input: BatchSuggestionInput;
};

export type QueryVehicleTimestampImagesDetailsArgs = {
  image_timestamp: Scalars['Float']['input'];
  images_before: Scalars['Int']['input'];
  vehicle_id: Scalars['String']['input'];
};

export type QueryVehicleTrackingArgs = {
  input?: InputMaybe<VehicleTrackingInput>;
};

export type QueryVehicleTrackingSegmentArgs = {
  input: VehicleTrackingSegmentInput;
};

export type QueryVehicleTripDistanceArgs = {
  input: VehicleTripDistanceInput;
};

export type QueryVehiclesArgs = {
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export enum RecordingResolution {
  Hd = 'HD',
  Nhd = 'NHD',
}

export type Recurrence = {
  __typename?: 'Recurrence';
  description?: Maybe<Scalars['String']['output']>;
  everyDays?: Maybe<Scalars['Int']['output']>;
  everyKms?: Maybe<Scalars['Int']['output']>;
};

export enum RecurrencyFrequency {
  Daily = 'DAILY',
  Monthly = 'MONTHLY',
  None = 'NONE',
  Weekly = 'WEEKLY',
}

export type ReminderDto = {
  __typename?: 'ReminderDTO';
  description?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  lastMaintenanceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceDate?: Maybe<Scalars['DateTime']['output']>;
  nextOccurrenceInKm?: Maybe<Scalars['Float']['output']>;
  recurrenceInDays?: Maybe<Scalars['Int']['output']>;
  recurrenceInKm?: Maybe<Scalars['Int']['output']>;
  status: MaintenanceStatus;
  title?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ReminderStatusCount = {
  __typename?: 'ReminderStatusCount';
  delayed?: Maybe<Scalars['Int']['output']>;
  onTime?: Maybe<Scalars['Int']['output']>;
  warning?: Maybe<Scalars['Int']['output']>;
};

export type ReminderTitle = {
  __typename?: 'ReminderTitle';
  id: Scalars['ID']['output'];
  value: Scalars['String']['output'];
};

export type ReminderTitleInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export enum RequestedMediaStatus {
  /** @deprecated Use `MediaRequestStatus` instead. */
  Acknowledge = 'ACKNOWLEDGE',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Canceled = 'CANCELED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Corrupted = 'CORRUPTED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Failed = 'FAILED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Finished = 'FINISHED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Pending = 'PENDING',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Started = 'STARTED',
  /** @deprecated Use `MediaRequestStatus` instead. */
  Unavailable = 'UNAVAILABLE',
}

export type Return = ITicket & {
  __typename?: 'Return';
  addressInformation?: Maybe<AddressInformation>;
  arrivalOfDevicesAtCobli?: Maybe<Scalars['String']['output']>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientCNPJ?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deadline?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  penaltyPrice?: Maybe<Scalars['Float']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  postingDate?: Maybe<Scalars['String']['output']>;
  responsibleUser?: Maybe<User>;
  returnType?: Maybe<Scalars['String']['output']>;
  scheduleDate?: Maybe<Scalars['String']['output']>;
  shippingCode?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type RiskEvent = {
  __typename?: 'RiskEvent';
  coordinates: Coordinate;
  device: RiskEventDevice;
  driver: RiskEventDriver;
  media?: Maybe<Media>;
  timestamp: Scalars['DateTime']['output'];
  type: RiskEventType;
};

export type RiskEventMediaArgs = {
  input: RiskEventsInput;
};

export type RiskEventDevice = {
  __typename?: 'RiskEventDevice';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type RiskEventDriver = {
  __typename?: 'RiskEventDriver';
  id: Scalars['ID']['output'];
};

export enum RiskEventType {
  Anomaly = 'ANOMALY',
  DistractedDriving = 'DISTRACTED_DRIVING',
  HarshAcceleration = 'HARSH_ACCELERATION',
  HarshBreaking = 'HARSH_BREAKING',
  HarshCornering = 'HARSH_CORNERING',
  LaneDrift = 'LANE_DRIFT',
  StopSignViolated = 'STOP_SIGN_VIOLATED',
  Tailgating = 'TAILGATING',
  TrafficSpeedViolated = 'TRAFFIC_SPEED_VIOLATED',
  Unknown = 'UNKNOWN',
}

export type RiskEventsInput = {
  driver_id: Scalars['ID']['input'];
  end: Scalars['TimestampInMillis']['input'];
  media_types?: InputMaybe<Array<MediaType>>;
  severities?: InputMaybe<Array<Severity>>;
  start: Scalars['TimestampInMillis']['input'];
  triggers?: InputMaybe<Array<EventTrigger>>;
};

export type RoadSpeedLimitAlert = UserAlert & {
  __typename?: 'RoadSpeedLimitAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  severity?: Maybe<Severity>;
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type RoadSpeedLimitSettings = {
  __typename?: 'RoadSpeedLimitSettings';
  duration_above_limit_in_millis: Scalars['Int']['output'];
  severity: Severity;
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Route = {
  __typename?: 'Route';
  activities: Array<Activity>;
  break?: Maybe<RouteBreak>;
  created_at: Scalars['TimestampInMillis']['output'];
  device_id?: Maybe<Scalars['String']['output']>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  driver_name?: Maybe<Scalars['String']['output']>;
  end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_end_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  executed_start_time?: Maybe<Scalars['TimestampInMillis']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  planned_distance_in_meters: Scalars['Int']['output'];
  planned_duration: Scalars['TimeIntervalInMillis']['output'];
  points: Array<Coordinate>;
  propagation_type?: Maybe<PropagationType>;
  recurrency?: Maybe<RouteRecurrency>;
  settings?: Maybe<RouteSettings>;
  shared_id?: Maybe<Scalars['ID']['output']>;
  start_time: Scalars['TimestampInMillis']['output'];
  status: RouteStatus;
  type: RouteType;
  updated_at: Scalars['TimestampInMillis']['output'];
  vehicle_id?: Maybe<Scalars['ID']['output']>;
};

export type RouteBreak = {
  __typename?: 'RouteBreak';
  duration: Scalars['TimeIntervalInMillis']['output'];
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type RouteBreakInput = {
  duration: Scalars['TimeIntervalInMillis']['input'];
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type RouteRecurrency = {
  __typename?: 'RouteRecurrency';
  days_of_month?: Maybe<Array<Scalars['Int']['output']>>;
  days_of_week?: Maybe<Array<Scalars['Int']['output']>>;
  frequency: RecurrencyFrequency;
  id?: Maybe<Scalars['ID']['output']>;
  repeat_interval: Scalars['Int']['output'];
  until_date?: Maybe<Scalars['TimestampInMillis']['output']>;
  week_numbers?: Maybe<Array<Scalars['Int']['output']>>;
};

export type RouteRecurrencyUpdate = {
  days_of_month?: InputMaybe<Array<Scalars['Int']['input']>>;
  days_of_week?: InputMaybe<Array<Scalars['Int']['input']>>;
  frequency: RecurrencyFrequency;
  id?: InputMaybe<Scalars['ID']['input']>;
  repeat_interval: Scalars['Int']['input'];
  until_date?: InputMaybe<Scalars['TimestampInMillis']['input']>;
  week_numbers?: InputMaybe<Array<Scalars['Int']['input']>>;
};

export type RouteReport = {
  __typename?: 'RouteReport';
  activities: Array<ActivityReport>;
  distance?: Maybe<PlannedVsExecutedInt>;
  driver?: Maybe<Driver>;
  duration?: Maybe<PlannedVsExecutedDurationTimeInMillis>;
  end_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  start_time?: Maybe<PlannedVsExecutedTimestampInMillis>;
  status?: Maybe<RouteStatus>;
  vehicle?: Maybe<VehicleDto>;
};

export type RouteSettings = {
  __typename?: 'RouteSettings';
  break_window?: Maybe<RouteBreak>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  working_hours: WorkingHours;
};

export type RouteSettingsInput = {
  break_window?: InputMaybe<RouteBreakInput>;
  objectives: Array<RoutingObjective>;
  routing_type: RouteType;
  working_hours: WorkingHoursInput;
};

export type RouteStartOrEndInput = {
  id: Scalars['ID']['input'];
  time: Scalars['Long']['input'];
};

export enum RouteStatus {
  Delayed = 'DELAYED',
  Executed = 'EXECUTED',
  InProgress = 'IN_PROGRESS',
  PartiallyExecuted = 'PARTIALLY_EXECUTED',
  Planned = 'PLANNED',
  Unexecuted = 'UNEXECUTED',
}

export enum RouteType {
  Manual = 'MANUAL',
  Optimized = 'OPTIMIZED',
}

export type RouteUpdate = {
  activities?: InputMaybe<Array<InputMaybe<ActivityUpdate>>>;
  device_id?: InputMaybe<Scalars['String']['input']>;
  driver_id?: InputMaybe<Scalars['ID']['input']>;
  driver_name?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  propagation_type?: InputMaybe<PropagationType>;
  recurrency?: InputMaybe<RouteRecurrencyUpdate>;
  settings?: InputMaybe<RouteSettingsInput>;
  vehicle_id?: InputMaybe<Scalars['ID']['input']>;
};

export type RoutesSummary = {
  __typename?: 'RoutesSummary';
  routes_with_vehicle: ExecutionDigestSummary;
  routes_without_vehicle: ExecutionDigestSummary;
  total: Scalars['Int']['output'];
};

export enum RoutingObjective {
  MinCompletionTime = 'MIN_COMPLETION_TIME',
  MinTransportTime = 'MIN_TRANSPORT_TIME',
  MinVehicles = 'MIN_VEHICLES',
}

export type RoutingOptimization = {
  break?: InputMaybe<RouteBreakInput>;
  end_route_destination?: InputMaybe<DestinationInput>;
  num_vehicles: Scalars['Int']['input'];
  objectives?: InputMaybe<Array<RoutingObjective>>;
  vehicle_average_cargo_capacity?: InputMaybe<Scalars['Int']['input']>;
  working_hours: WorkingHoursInput;
};

export type RoutingSettings = {
  activities: Array<InputActivity>;
  optimization?: InputMaybe<RoutingOptimization>;
  start_time: Scalars['TimestampInMillis']['input'];
  type: RouteType;
};

export enum RuleCategory {
  DeviceHealthStatusObservationPeriod = 'DEVICE_HEALTH_STATUS_OBSERVATION_PERIOD',
  Geofence = 'GEOFENCE',
  IdleEngine = 'IDLE_ENGINE',
}

export enum RuleMode {
  BackgroundPolicy = 'BACKGROUND_POLICY',
  FleetPolicy = 'FLEET_POLICY',
}

export type SafetyOccurrence = {
  __typename?: 'SafetyOccurrence';
  /** Safety occurrence ID */
  id: Scalars['ID']['output'];
  /** Safety occurrence name */
  name: Scalars['String']['output'];
};

export type SafetyRankingInput = {
  endDate: Scalars['DateTime']['input'];
  startDate: Scalars['DateTime']['input'];
  timezone: Scalars['String']['input'];
};

export type SafetyRankingParams = {
  __typename?: 'SafetyRankingParams';
  cameraCorrectionWeights: SafetyRankingParamsValues;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  params: SafetyRankingParamsValues;
  telemetryCorrectionWeights: SafetyRankingParamsValues;
  user?: Maybe<FleetUser>;
};

export type SafetyRankingParamsInput = {
  referenceDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type SafetyRankingParamsValues = {
  __typename?: 'SafetyRankingParamsValues';
  distractedDriving?: Maybe<Scalars['Float']['output']>;
  eyesClosed?: Maybe<Scalars['Float']['output']>;
  fastAcceleration?: Maybe<Scalars['Float']['output']>;
  hardBreak?: Maybe<Scalars['Float']['output']>;
  ignoreDismissedEvents?: Maybe<Scalars['Boolean']['output']>;
  minDistanceInKm?: Maybe<Scalars['Int']['output']>;
  phoneUsage?: Maybe<Scalars['Float']['output']>;
  roadSpeedLimit?: Maybe<Scalars['Float']['output']>;
  smoking?: Maybe<Scalars['Float']['output']>;
  speedyTurn?: Maybe<Scalars['Float']['output']>;
  tailgating?: Maybe<Scalars['Float']['output']>;
  vehicleSpeedLimit?: Maybe<Scalars['Float']['output']>;
  yawn?: Maybe<Scalars['Float']['output']>;
};

export type SafetyRankingProductType = {
  __typename?: 'SafetyRankingProductType';
  productType: Scalars['String']['output'];
};

export type SafetyRankingProductivity = {
  __typename?: 'SafetyRankingProductivity';
  averageKmPerVehicle: Scalars['Float']['output'];
};

export type SafetyRankingScoreDetail = {
  __typename?: 'SafetyRankingScoreDetail';
  discount: Scalars['Float']['output'];
  eventType: Scalars['String']['output'];
  frequency: Scalars['Float']['output'];
  occurrences: Scalars['Int']['output'];
};

export type SafetyRankingScoreRow = {
  __typename?: 'SafetyRankingScoreRow';
  drivenDistanceInKm: Scalars['Int']['output'];
  drivenTimeInMinutes: Scalars['Int']['output'];
  kmsPerEvent?: Maybe<Scalars['Float']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  rank?: Maybe<Scalars['Int']['output']>;
  score?: Maybe<Scalars['Int']['output']>;
  scoreDetail: Array<SafetyRankingScoreDetail>;
  totalEventsCount?: Maybe<Scalars['Int']['output']>;
  variation?: Maybe<Scalars['Int']['output']>;
};

export type SafetyRankingScores = {
  __typename?: 'SafetyRankingScores';
  averageFleetScore?: Maybe<Scalars['Int']['output']>;
  classifiedCount: Scalars['Int']['output'];
  count: Scalars['Int']['output'];
  lastRankUpdate?: Maybe<Scalars['DateTime']['output']>;
  rows: Array<SafetyRankingScoreRow>;
  unclassifiedCount: Scalars['Int']['output'];
};

export type SafetyReview = {
  __typename?: 'SafetyReview';
  /** Datetime of review creation */
  created_at: Scalars['String']['output'];
  /** ID of the User that first reviewed */
  created_by: Scalars['ID']['output'];
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Cobli driver associated with review. */
  driver?: Maybe<Driver>;
  /** Driver ID associated with review */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /**
   * Name of the driver associated with review
   * @deprecated Use `driver` field instead
   */
  driver_name?: Maybe<Scalars['String']['output']>;
  /** Fleet ID */
  fleet_id: Scalars['ID']['output'];
  /** Safety review ID */
  id: Scalars['ID']['output'];
  /** Safety occurrences associated with review */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** First Driver ID associated before review */
  original_media_driver_id?: Maybe<Scalars['ID']['output']>;
  /** First Severity associated before review */
  original_media_severity?: Maybe<Scalars['String']['output']>;
  /** reviewed Severity */
  severity?: Maybe<Scalars['String']['output']>;
  /** Current safety review status */
  status?: Maybe<Scalars['String']['output']>;
  /** Datetime of review last update */
  updated_at: Scalars['String']['output'];
  /** ID of the User that last updated */
  updated_by: Scalars['ID']['output'];
  /** User that last updated */
  updated_by_user?: Maybe<FleetUser>;
};

export type SafetyReviewHistory = {
  __typename?: 'SafetyReviewHistory';
  /** Datetime of the History record creation */
  created_at: Scalars['String']['output'];
  /** ID of the History record */
  id: Scalars['ID']['output'];
  /** Safety Review entity snapshot */
  snapshot: SafetyReviewSnapshot;
  /** User who created the record */
  user?: Maybe<FleetUser>;
  /** ID of the User who created the record */
  user_id: Scalars['ID']['output'];
};

export type SafetyReviewHistoryPage = {
  __typename?: 'SafetyReviewHistoryPage';
  content?: Maybe<Array<Maybe<SafetyReviewHistory>>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type SafetyReviewSnapshot = {
  __typename?: 'SafetyReviewSnapshot';
  /** Indicates the reason for dismissal */
  dismiss_reason?: Maybe<Scalars['String']['output']>;
  /** Driver associated at the snapshot time */
  driver?: Maybe<Driver>;
  /** Driver ID associated at the snapshot time */
  driver_id?: Maybe<Scalars['ID']['output']>;
  /** Safety Occurrences at the snapshot time */
  occurrences?: Maybe<Array<Maybe<SafetyOccurrence>>>;
  /** Severity at the snapshot time */
  severity?: Maybe<Scalars['String']['output']>;
  /** Review status at the snapshot time */
  status?: Maybe<Scalars['String']['output']>;
};

export type Scheduling = ITicket & {
  __typename?: 'Scheduling';
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  clientInformation?: Maybe<ClientInformation>;
  coblerInformation?: Maybe<CoblerInformation>;
  contactInformation?: Maybe<ContactInformation>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  dateInformation?: Maybe<DateInformation>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  fieldControlInformation?: Maybe<FieldControlInformation>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  installedDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  scheduledDate?: Maybe<Scalars['TimestampInMillis']['output']>;
  scheduledTime?: Maybe<Scalars['TimestampInMillis']['output']>;
  schedulingSubCategory?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
  vehicleInformation?: Maybe<VehicleInformation>;
};

export type SeatbeltDetection = {
  __typename?: 'SeatbeltDetection';
  with_seatbelt?: Maybe<Scalars['Boolean']['output']>;
};

export type SelectContent = {
  __typename?: 'SelectContent';
  options: Array<OptionContent>;
};

export type SendImageObstructionFeedback = {
  /** Image UUID identifier */
  image_id: Scalars['String']['input'];
  /** User given feedback class */
  obstruction_feedback: Scalars['String']['input'];
  /** Trip identifier */
  trip_id: Scalars['String']['input'];
};

export type SendInviteResponse = {
  __typename?: 'SendInviteResponse';
  invites?: Maybe<Array<Maybe<InviteResponse>>>;
  status: Scalars['String']['output'];
};

export type SendInvitesResponse = {
  __typename?: 'SendInvitesResponse';
  invites?: Maybe<SendInviteResponse>;
};

export enum Sensibility {
  Default = 'DEFAULT',
  Maximum = 'MAXIMUM',
  Minimum = 'MINIMUM',
  ModeratelyHigh = 'MODERATELY_HIGH',
  ModeratelyLow = 'MODERATELY_LOW',
}

export type SensibilityConfiguration = {
  __typename?: 'SensibilityConfiguration';
  enabled: Scalars['Boolean']['output'];
  sensibility: Sensibility;
};

export type SensibilityConfigurationInput = {
  enabled: Scalars['Boolean']['input'];
  sensibility: Sensibility;
};

export type Servicos = {
  __typename?: 'Servicos';
  coAbanQtdDesinstalacaoInstaladoMotosOuMaquinariosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCliente?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoInstaladoVeiculosLevesOuPesadosCoblicam?: Maybe<Scalars['Int']['output']>;
  coAbanQtdDesinstalacaoRemovivelVeiculosPesados?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2130?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Bloqueador?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao2630Ibutton?: Maybe<Scalars['Int']['output']>;
  csAbanQtdDesinstalacao3030?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadiga?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoInstaladoLevesOuPesadosCameraFadigaPremium?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosBuzzer?: Maybe<Scalars['Int']['output']>;
  quantidadeDesinstalacaoRemovivelLevesOuPesadosIdentificador?: Maybe<Scalars['Int']['output']>;
  supplyDesinstalacaoCalculoTotal?: Maybe<Scalars['Int']['output']>;
};

export type SettingsJson = RoadSpeedLimitSettings | StopIdleTimeSettings | VehicleSpeedLimitSettings;

export type SettingsJsonInput = {
  /** ROAD SPEED LIMIT. VEHICLE SPEED LIMIT also uses the duration */
  duration_above_limit_in_millis?: InputMaybe<Scalars['Int']['input']>;
  /** STOP IDLE TIME */
  duration_idle_in_millis?: InputMaybe<Scalars['Int']['input']>;
  severity?: InputMaybe<Severity>;
  vehicle_group_ids: Array<InputMaybe<Scalars['ID']['input']>>;
};

export type SeveritiesSummary = {
  __typename?: 'SeveritiesSummary';
  high: Scalars['Int']['output'];
  higher: Scalars['Int']['output'];
  low: Scalars['Int']['output'];
  medium: Scalars['Int']['output'];
};

export enum Severity {
  High = 'HIGH',
  Higher = 'HIGHER',
  Low = 'LOW',
  Medium = 'MEDIUM',
}

export type SeverityDetail = {
  __typename?: 'SeverityDetail';
  id: Scalars['ID']['output'];
  /** List of identified risk factors */
  risk_factors?: Maybe<Array<Maybe<SeverityRiskFactor>>>;
  /** Severity level according to score */
  severity_level: Severity;
  /** Severity score */
  severity_score?: Maybe<Scalars['Int']['output']>;
};

export type SeverityRiskFactor = {
  __typename?: 'SeverityRiskFactor';
  /** Customized details for the risk kind */
  custom_details?: Maybe<Scalars['JSONObject']['output']>;
  id: Scalars['ID']['output'];
  /** Identifier of the risk kind */
  type: Scalars['String']['output'];
  /** Risk factor multiplier value */
  value: Scalars['Float']['output'];
};

export type Shipping = ITicket & {
  __typename?: 'Shipping';
  addressInformation?: Maybe<AddressInformation>;
  associatedDealId?: Maybe<Scalars['String']['output']>;
  contactName?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  deletedAt?: Maybe<Scalars['TimestampInMillis']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  deviceCobliIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  deviceTotalQuantity?: Maybe<DeviceTotalQuantity>;
  devicesWithInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  devicesWithoutInstallation?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  estimatedTimeOfArrival?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  pipeline?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  shippingDate?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
  type: Scalars['String']['output'];
};

export type ShippingInformation = {
  __typename?: 'ShippingInformation';
  address?: Maybe<Scalars['String']['output']>;
  deviceInformation?: Maybe<DeviceShippingInformation>;
  estimatedReceivingDate?: Maybe<Scalars['String']['output']>;
  shippingCompany?: Maybe<Scalars['String']['output']>;
  shippingCompanyLink?: Maybe<Scalars['String']['output']>;
  trackingCode?: Maybe<Scalars['String']['output']>;
};

export type Sort = {
  column: Scalars['String']['input'];
  order: Order;
};

export type SortType = {
  __typename?: 'SortType';
  empty?: Maybe<Scalars['Boolean']['output']>;
  sorted?: Maybe<Scalars['Boolean']['output']>;
  unsorted?: Maybe<Scalars['Boolean']['output']>;
};

export type SpeedEvent = {
  __typename?: 'SpeedEvent';
  driverName?: Maybe<Scalars['String']['output']>;
  durationAboveInMillis?: Maybe<Scalars['Float']['output']>;
  eventTime: Scalars['Float']['output'];
  location: Location;
  medianBasedSeverity?: Maybe<Scalars['String']['output']>;
  medianSpeedInKmh?: Maybe<Scalars['Float']['output']>;
  severity: Scalars['String']['output'];
  speedInKmh: Scalars['Float']['output'];
  speedLimitInKmh: Scalars['Float']['output'];
  startTime?: Maybe<Scalars['Float']['output']>;
  type: Scalars['String']['output'];
};

export type SpeedLimitUpdateInput = {
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
  /** The duty type of the vehicle. */
  duty_type?: InputMaybe<DutyType>;
  /** The desired speed limit */
  speed_limit_warning_in_kmph?: InputMaybe<Scalars['Float']['input']>;
};

export type SpreadsheetActivity = {
  __typename?: 'SpreadsheetActivity';
  additional_info?: Maybe<Scalars['String']['output']>;
  destination?: Maybe<SpreadsheetDestination>;
  duration?: Maybe<Scalars['TimeIntervalInMillis']['output']>;
  load_size?: Maybe<Scalars['Int']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phone_number?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  start_hour?: Maybe<Scalars['String']['output']>;
  time_windows?: Maybe<Array<Maybe<SpreadsheetTimeWindow>>>;
};

export type SpreadsheetDestination = {
  __typename?: 'SpreadsheetDestination';
  city?: Maybe<Scalars['String']['output']>;
  coordinate: Coordinate;
  country?: Maybe<Scalars['String']['output']>;
  neighborhood?: Maybe<Scalars['String']['output']>;
  postal_code?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  street_address?: Maybe<Scalars['String']['output']>;
  street_complement?: Maybe<Scalars['String']['output']>;
  street_number?: Maybe<Scalars['String']['output']>;
};

export type SpreadsheetImportResultAddress = {
  __typename?: 'SpreadsheetImportResultAddress';
  activity?: Maybe<SpreadsheetActivity>;
  query_address: Scalars['String']['output'];
};

export type SpreadsheetRow = {
  additional_info?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['String']['input'];
  load_size?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  phone_number?: InputMaybe<Scalars['String']['input']>;
  start_date?: InputMaybe<Scalars['String']['input']>;
  start_hour?: InputMaybe<Scalars['String']['input']>;
  time_window?: InputMaybe<Scalars['String']['input']>;
};

export type SpreadsheetTimeWindow = {
  __typename?: 'SpreadsheetTimeWindow';
  earliest?: Maybe<Scalars['TimestampInMillis']['output']>;
  latest?: Maybe<Scalars['TimestampInMillis']['output']>;
};

export type StopIdleTimeAlert = UserAlert & {
  __typename?: 'StopIdleTimeAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type StopIdleTimeSettings = {
  __typename?: 'StopIdleTimeSettings';
  duration_idle_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type Stops = {
  __typename?: 'Stops';
  driverName?: Maybe<Scalars['String']['output']>;
  endTime: Scalars['Float']['output'];
  geofences: Array<Maybe<Geofences>>;
  hasFilteredIdleOnTime?: Maybe<Scalars['Boolean']['output']>;
  idleOffInMillis: Scalars['Float']['output'];
  idleOnInMillis: Scalars['Float']['output'];
  location: Location;
  startTime: Scalars['Float']['output'];
};

export type SumTotalCostByFuelTypeResponse = {
  __typename?: 'SumTotalCostByFuelTypeResponse';
  endInterval: Scalars['String']['output'];
  fuelType: Scalars['String']['output'];
  isCompleted: Scalars['Boolean']['output'];
  startInterval: Scalars['String']['output'];
  totalCost: Scalars['Float']['output'];
};

export type Summary = {
  __typename?: 'Summary';
  totalDistance: Scalars['Float']['output'];
  totalDuration: Scalars['Float']['output'];
  totalFuelCost: Scalars['Float']['output'];
  totalGeofenceEvents: Scalars['Int']['output'];
  totalSpeedEvents: Scalars['Int']['output'];
  totalStops: Scalars['Int']['output'];
};

export type Supplier = {
  __typename?: 'Supplier';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TextContent = {
  __typename?: 'TextContent';
  value?: Maybe<Scalars['String']['output']>;
};

export type Ticket = {
  __typename?: 'Ticket';
  closedDate?: Maybe<Scalars['String']['output']>;
  conclusionDate?: Maybe<Scalars['String']['output']>;
  content?: Maybe<Scalars['String']['output']>;
  createDate?: Maybe<Scalars['String']['output']>;
  devolutionInformation?: Maybe<DevolutionInformation>;
  id: Scalars['String']['output'];
  installationInformation?: Maybe<InstallationInformation>;
  lastActivityDate?: Maybe<Scalars['String']['output']>;
  lastModifiedDate?: Maybe<Scalars['String']['output']>;
  nextActivityDate?: Maybe<Scalars['String']['output']>;
  notesLastUpdated?: Maybe<Scalars['String']['output']>;
  notesNextActivityDate?: Maybe<Scalars['String']['output']>;
  originTicketId?: Maybe<Scalars['String']['output']>;
  panelFormTest?: Maybe<Scalars['Boolean']['output']>;
  pipeline?: Maybe<Scalars['String']['output']>;
  pipelineStage?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['String']['output']>;
  resolution?: Maybe<Scalars['String']['output']>;
  servicos?: Maybe<Servicos>;
  shippingInformation?: Maybe<ShippingInformation>;
  sourceType?: Maybe<Scalars['String']['output']>;
  subject?: Maybe<Scalars['String']['output']>;
  ticketAssociatedDealId?: Maybe<Scalars['String']['output']>;
};

export type Tickets = {
  __typename?: 'Tickets';
  tickets?: Maybe<Array<Ticket>>;
  total: Scalars['Int']['output'];
};

export type TimeWindow = {
  __typename?: 'TimeWindow';
  earliest: Scalars['TimestampInMillis']['output'];
  latest: Scalars['TimestampInMillis']['output'];
};

export type TimeWindowInput = {
  earliest: Scalars['TimestampInMillis']['input'];
  latest: Scalars['TimestampInMillis']['input'];
};

export type ToggleChecklistActive = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
};

export type TotalAndIdsReportSummary = {
  __typename?: 'TotalAndIdsReportSummary';
  ids: Array<Scalars['ID']['output']>;
  total?: Maybe<Scalars['Int']['output']>;
};

export type Tracking = {
  __typename?: 'Tracking';
  device?: Maybe<DeviceFields>;
  deviceId?: Maybe<Scalars['String']['output']>;
  drivers: Array<Maybe<Driver>>;
  endTime: Scalars['TimestampInMillis']['output'];
  geofenceEvents?: Maybe<Array<Maybe<GeofenceEvent>>>;
  groupIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  incidents?: Maybe<Array<Maybe<Incidents>>>;
  lastPath?: Maybe<LastPath>;
  pathGeojson: PathGeojson;
  roadSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
  startTime: Scalars['TimestampInMillis']['output'];
  stops?: Maybe<Array<Maybe<Stops>>>;
  summary?: Maybe<Summary>;
  tz: Scalars['String']['output'];
  vehicle?: Maybe<VehicleFields>;
  vehicleId?: Maybe<Scalars['ID']['output']>;
  vehicleSpeedEvents?: Maybe<Array<Maybe<SpeedEvent>>>;
};

export type TrackingInput = {
  device_id: Scalars['String']['input'];
  end_time: Scalars['Float']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
};

export type TrainingVideo = {
  __typename?: 'TrainingVideo';
  categoryId?: Maybe<Scalars['ID']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  thumbnail?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideoCategory = {
  __typename?: 'TrainingVideoCategory';
  id?: Maybe<Scalars['ID']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

export type TrainingVideos = {
  __typename?: 'TrainingVideos';
  category?: Maybe<TrainingVideoCategory>;
  trainingVideos?: Maybe<Array<Maybe<TrainingVideo>>>;
};

export type Trigger = {
  __typename?: 'Trigger';
  active: Scalars['Boolean']['output'];
  allowNotifications: Scalars['Boolean']['output'];
  condition: TriggerCondition;
  createdAt: Scalars['String']['output'];
  daysOfWeek: Array<Scalars['Int']['output']>;
  deviceIds: Array<Scalars['String']['output']>;
  endTime: Scalars['String']['output'];
  geofenceIds: Array<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  notifiedUsers: Array<Maybe<UserFleets>>;
  startTime: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  updatedBy?: Maybe<UserFleets>;
  vehicleGroupIds: Array<Scalars['ID']['output']>;
  vehicleIds: Array<Scalars['ID']['output']>;
};

export type TriggerCondition = {
  __typename?: 'TriggerCondition';
  category: ConditionCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  params: Array<Maybe<Scalars['String']['output']>>;
  rule: TriggerConditionRule;
};

export type TriggerConditionRule = {
  __typename?: 'TriggerConditionRule';
  category: RuleCategory;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type TriggerListFilter = {
  active?: InputMaybe<Scalars['Boolean']['input']>;
  conditionId?: InputMaybe<Scalars['ID']['input']>;
  createdBy?: InputMaybe<Scalars['ID']['input']>;
  daysOfWeek?: InputMaybe<Array<Scalars['Int']['input']>>;
  geofenceIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  myNotifications?: InputMaybe<Scalars['Boolean']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  requestVideo?: InputMaybe<Scalars['Boolean']['input']>;
  ruleCategory?: InputMaybe<RuleCategory>;
  ruleMode?: InputMaybe<RuleMode>;
  triggerIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleGroupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds?: InputMaybe<Array<Scalars['ID']['input']>>;
};

export type TriggerPage = {
  __typename?: 'TriggerPage';
  content?: Maybe<Array<Trigger>>;
  empty?: Maybe<Scalars['Boolean']['output']>;
  first?: Maybe<Scalars['Boolean']['output']>;
  last?: Maybe<Scalars['Boolean']['output']>;
  number?: Maybe<Scalars['Int']['output']>;
  number_of_elements?: Maybe<Scalars['Int']['output']>;
  pageable?: Maybe<PageableObject>;
  size?: Maybe<Scalars['Int']['output']>;
  sort?: Maybe<SortType>;
  total_elements?: Maybe<Scalars['Int']['output']>;
  total_pages?: Maybe<Scalars['Int']['output']>;
};

export type Trip = {
  __typename?: 'Trip';
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Identifier. */
  id?: Maybe<Scalars['String']['output']>;
  /** Flag indicating whether the trip is available for requesting or not. */
  is_footage_available: Scalars['Boolean']['output'];
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
};

export type TripImage = {
  __typename?: 'TripImage';
  /** Whether the trip images were marked with a driver visible or not visible */
  driver_visibility?: Maybe<DriverVisibility>;
  /** Trip end Unix timestamp in millis. */
  end_timestamp: Scalars['TimestampInMillis']['output'];
  /** Identification method utilized at the time. */
  identification_method: Scalars['String']['output'];
  /** The timestamp that the user has nominated an image formatted as Unix timestamp in millis. */
  nominated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  /** The user that nominated the trip. */
  nominated_by?: Maybe<User>;
  /** The driver recognized by the faceID. */
  recognized_driver?: Maybe<Driver>;
  /** Trip start Unix timestamp in millis. */
  start_timestamp: Scalars['TimestampInMillis']['output'];
  /** The id of the trip. */
  trip_id: Scalars['String']['output'];
  /** An image sample of the trip. */
  trip_image_sample?: Maybe<TripImageDetails>;
  /** List of images from the trip. It will only be filled when one single trip were selected. */
  trip_images?: Maybe<Array<Maybe<TripImageDetails>>>;
  /** The driver nominated by the user. */
  user_nominated_driver?: Maybe<Driver>;
  /** The id of the vehicle with the media. */
  vehicle: VehicleDto;
};

export type TripImageDetails = {
  __typename?: 'TripImageDetails';
  id: Scalars['ID']['output'];
  image_url: Scalars['String']['output'];
  is_obstructed?: Maybe<Scalars['Boolean']['output']>;
  obstruction_feedback?: Maybe<Scalars['String']['output']>;
};

export type UpdateAssociationPayloadInput = {
  input: AssociationConfigInput;
};

export type UpdateAudioRequest = {
  /** The status of the camera audio. */
  audio_status: AudioStatus;
  /** Device identifier. A number between 10 and 15 digits */
  device_id: Scalars['String']['input'];
};

export type UpdateChecklist = {
  id: Scalars['ID']['input'];
  updatedChecklist: UpdatedChecklist;
};

export type UpdateContactTrainingInfoInput = {
  finishedVideos: Array<InputMaybe<VideoInfo>>;
  startedVideos: Array<InputMaybe<VideoInfo>>;
};

export type UpdateDeviceParameter = {
  device_id: Scalars['String']['input'];
  parameters: Array<ParameterInput>;
};

export type UpdateDriver = {
  cpf?: InputMaybe<Scalars['String']['input']>;
  driver_license?: InputMaybe<Scalars['String']['input']>;
  first_license_acquirement_date?: InputMaybe<Scalars['Date']['input']>;
  id: Scalars['ID']['input'];
  license_category?: InputMaybe<Scalars['String']['input']>;
  license_expiration_date?: InputMaybe<Scalars['Date']['input']>;
  name: Scalars['String']['input'];
  phone_number?: InputMaybe<Scalars['String']['input']>;
  registry_id?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateEventsConfigurationInput = {
  events_configuration: EventsConfigurationInput;
};

export type UpdateFuelCardAssociationInput = {
  id: Scalars['ID']['input'];
  source?: InputMaybe<Scalars['String']['input']>;
  vehicleId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateFuelTransactionInput = {
  commodity: Scalars['String']['input'];
  id: Scalars['ID']['input'];
  merchant?: InputMaybe<MerchantUpdateInput>;
  odometerInKms?: InputMaybe<Scalars['Float']['input']>;
  totalCost: Scalars['Float']['input'];
  transactionerName?: InputMaybe<Scalars['String']['input']>;
  units: Scalars['Float']['input'];
};

export type UpdateMaintenanceHistoryInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  parts?: InputMaybe<Array<InputMaybe<MaintenancePartInput>>>;
  totalPrice?: InputMaybe<Scalars['Float']['input']>;
};

export type UpdateMaintenancePartsInput = {
  description: Scalars['String']['input'];
  id: Scalars['ID']['input'];
};

export type UpdateParameterResponse = {
  __typename?: 'UpdateParameterResponse';
  device_id: Scalars['String']['output'];
  parameters: Array<Parameter>;
};

export type UpdateReminderInput = {
  description?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['ID']['input'];
  recurrenceInDays?: InputMaybe<Scalars['Int']['input']>;
  recurrenceInKm?: InputMaybe<Scalars['Int']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
  title: ReminderTitleInput;
};

export type UpdateUserNotificationSettings = {
  active: Scalars['Boolean']['input'];
  id: Scalars['ID']['input'];
  settings_json: SettingsJsonInput;
  type: UserNotificationSettingsType;
};

export type UpdateUserTrainingMediaInput = {
  action: UserTrainingMediaActionType;
  trainingMediaId: Scalars['ID']['input'];
};

export type UpdateVehicleImmobilizerInput = {
  driverIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  id: Scalars['ID']['input'];
  isImmobilizerEnabled: Scalars['Boolean']['input'];
  vehicleDriverAuthorizationMode?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateVehicleInput = {
  alias?: InputMaybe<Scalars['String']['input']>;
  brand?: InputMaybe<Scalars['String']['input']>;
  driverId?: InputMaybe<Scalars['ID']['input']>;
  fuelConsumption?: InputMaybe<Scalars['Float']['input']>;
  fuelPrice?: InputMaybe<Scalars['Float']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  groupIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['String']['input']>;
  speedInKmh?: InputMaybe<Scalars['Float']['input']>;
  tagNames?: InputMaybe<Array<Scalars['String']['input']>>;
  type?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatedChecklist = {
  context?: InputMaybe<NewChecklistContext>;
  fields: Array<NewChecklistField>;
  name: Scalars['String']['input'];
  template_active?: InputMaybe<Scalars['Boolean']['input']>;
  vehicle_group_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicle_ids?: InputMaybe<Array<Scalars['ID']['input']>>;
  version: Scalars['Int']['input'];
};

export type User = {
  __typename?: 'User';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type UserActivationTask = {
  __typename?: 'UserActivationTask';
  category: Scalars['String']['output'];
  created_at: Scalars['DateTime']['output'];
  finished: Scalars['Boolean']['output'];
  fleet_id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  step_id?: Maybe<Scalars['ID']['output']>;
  task_id: Scalars['ID']['output'];
  updated_at?: Maybe<Scalars['DateTime']['output']>;
  user_id: Scalars['ID']['output'];
};

export type UserActivationTaskInput = {
  finished: Scalars['Boolean']['input'];
  stepId: Scalars['ID']['input'];
  taskId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserAlert = {
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type UserAttributes = {
  __typename?: 'UserAttributes';
  creation_date?: Maybe<Scalars['String']['output']>;
  num_devices?: Maybe<Scalars['Int']['output']>;
};

export type UserDefaultRoles = {
  __typename?: 'UserDefaultRoles';
  name?: Maybe<Scalars['String']['output']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type UserFleets = {
  __typename?: 'UserFleets';
  active?: Maybe<Scalars['Boolean']['output']>;
  associated_at?: Maybe<Scalars['String']['output']>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  granted_permissions: Array<Scalars['String']['output']>;
  groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  groups_restriction?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  has_no_valid_groups: Scalars['Boolean']['output'];
  has_only_groups_with_no_vehicles: Scalars['Boolean']['output'];
  id?: Maybe<Scalars['ID']['output']>;
  managers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  name?: Maybe<Scalars['String']['output']>;
  role?: Maybe<Scalars['String']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
};

export type UserInput = {
  userId?: InputMaybe<Scalars['ID']['input']>;
};

export type UserNotificationSettings = {
  __typename?: 'UserNotificationSettings';
  active: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  settings_json: SettingsJson;
  type: UserNotificationSettingsType;
};

export enum UserNotificationSettingsType {
  RoadSpeedLimit = 'ROAD_SPEED_LIMIT',
  StopIdleTime = 'STOP_IDLE_TIME',
  VehicleSpeedLimit = 'VEHICLE_SPEED_LIMIT',
}

export type UserPreferences = {
  __typename?: 'UserPreferences';
  created_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  filtered_groups?: Maybe<Array<Maybe<VehiclesGroup>>>;
  fleet_id?: Maybe<Scalars['ID']['output']>;
  id?: Maybe<Scalars['ID']['output']>;
  updated_at?: Maybe<Scalars['TimestampInMillis']['output']>;
  use_vehicles_cluster?: Maybe<Scalars['Boolean']['output']>;
  user_id?: Maybe<Scalars['ID']['output']>;
  vehicle_group_ids?: Maybe<Array<Maybe<Scalars['ID']['output']>>>;
};

export type UserTrainingMedia = {
  __typename?: 'UserTrainingMedia';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  finishedAt?: Maybe<Scalars['DateTime']['output']>;
  startedAt?: Maybe<Scalars['DateTime']['output']>;
  trainingMediaId?: Maybe<Scalars['ID']['output']>;
  userId?: Maybe<Scalars['ID']['output']>;
};

export enum UserTrainingMediaActionType {
  Finish = 'FINISH',
  Start = 'START',
}

export type ValidateExpensesImportInput = {
  columnMap: ExpensesImportColumnMap;
  data: Array<ValidateExpensesImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateExpensesImportInputItem = {
  categoryName: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  observation?: InputMaybe<Scalars['String']['input']>;
  occurredAt: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  supplierName?: InputMaybe<Scalars['String']['input']>;
  totalCost: Scalars['String']['input'];
  type: Scalars['String']['input'];
};

export type ValidateExpensesImportItem = {
  __typename?: 'ValidateExpensesImportItem';
  categoryName: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type ValidateExpensesImportResponse = {
  __typename?: 'ValidateExpensesImportResponse';
  invalidRows: Array<ValidateExpensesInvalidRowsResponse>;
  validRows: Array<ValidateExpensesValidRowsResponse>;
};

export type ValidateExpensesInvalidRowsResponse = {
  __typename?: 'ValidateExpensesInvalidRowsResponse';
  data: ValidateExpensesImportItem;
  errors: Array<ValidationError>;
};

export type ValidateExpensesValidRowsResponse = {
  __typename?: 'ValidateExpensesValidRowsResponse';
  categoryId: Scalars['String']['output'];
  groupPath?: Maybe<Scalars['String']['output']>;
  observation?: Maybe<Scalars['String']['output']>;
  occurredAt: Scalars['String']['output'];
  supplierName?: Maybe<Scalars['String']['output']>;
  totalCost: Scalars['Float']['output'];
  type: Scalars['String']['output'];
  vehicleId: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportInput = {
  columnMap: FuelTransactionsImportColumnMap;
  data: Array<ValidateFuelTransactionsImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportInputItem = {
  fuelType: Scalars['String']['input'];
  licensePlate: Scalars['String']['input'];
  merchantCity?: InputMaybe<Scalars['String']['input']>;
  merchantCnpj?: InputMaybe<Scalars['String']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  merchantState?: InputMaybe<Scalars['String']['input']>;
  odometer: Scalars['String']['input'];
  quantityInLiters: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  totalCost: Scalars['String']['input'];
  transactionTime: Scalars['String']['input'];
};

export type ValidateFuelTransactionsImportItem = {
  __typename?: 'ValidateFuelTransactionsImportItem';
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchantCity?: Maybe<Scalars['String']['output']>;
  merchantCnpj?: Maybe<Scalars['String']['output']>;
  merchantName?: Maybe<Scalars['String']['output']>;
  merchantState?: Maybe<Scalars['String']['output']>;
  odometer: Scalars['String']['output'];
  quantityInLiters: Scalars['String']['output'];
  rowIndex: Scalars['Int']['output'];
  totalCost: Scalars['String']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateFuelTransactionsImportResponse = {
  __typename?: 'ValidateFuelTransactionsImportResponse';
  invalidRows: Array<ValidateFuelTransactionsInvalidRowsResponse>;
  validRows: Array<ValidateFuelTransactionsValidRowsResponse>;
};

export type ValidateFuelTransactionsInvalidRowsResponse = {
  __typename?: 'ValidateFuelTransactionsInvalidRowsResponse';
  data: ValidateFuelTransactionsImportItem;
  errors: Array<ValidationError>;
};

export type ValidateFuelTransactionsValidRowsResponse = {
  __typename?: 'ValidateFuelTransactionsValidRowsResponse';
  fuelType: Scalars['String']['output'];
  licensePlate: Scalars['String']['output'];
  merchant?: Maybe<MerchantImportResponse>;
  odometerInKm: Scalars['Float']['output'];
  quantityInLiters: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  transactionTime: Scalars['String']['output'];
};

export type ValidateImportVehicleRowDto = {
  __typename?: 'ValidateImportVehicleRowDTO';
  fuelConsumption?: Maybe<Scalars['String']['output']>;
  fuelPrice?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['String']['output']>;
};

export type ValidateImportVehicleRowInput = {
  fuelConsumption?: InputMaybe<Scalars['String']['input']>;
  fuelPrice?: InputMaybe<Scalars['String']['input']>;
  fuelType?: InputMaybe<Scalars['String']['input']>;
  licensePlate: Scalars['String']['input'];
  rowIndex: Scalars['Int']['input'];
  size?: InputMaybe<Scalars['String']['input']>;
  speedLimitInKmh?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateImportVehicleSpreadsheetInput = {
  columnMap: Array<ColumnMapEntryInput>;
  data: Array<ValidateImportVehicleRowInput>;
};

export type ValidateImportVehicleSpreadsheetResponse = {
  __typename?: 'ValidateImportVehicleSpreadsheetResponse';
  invalidRows: Array<InvalidImportVehicleRowDto>;
  validRows: Array<ImportVehicleRowDto>;
};

export type ValidateMaintenanceAggregatedPart = {
  __typename?: 'ValidateMaintenanceAggregatedPart';
  description?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  rowIndex: Scalars['Int']['output'];
  serviceItemName?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceImportInput = {
  columnMap: MaintenanceImportColumnMap;
  data: Array<ValidateMaintenanceImportInputItem>;
  timeZone: Scalars['String']['input'];
};

export type ValidateMaintenanceImportInputItem = {
  licensePlate?: InputMaybe<Scalars['String']['input']>;
  maintenanceObservations?: InputMaybe<Scalars['String']['input']>;
  occurrenceAt?: InputMaybe<Scalars['String']['input']>;
  odometerInKms?: InputMaybe<Scalars['String']['input']>;
  partName?: InputMaybe<Scalars['String']['input']>;
  partObservation?: InputMaybe<Scalars['String']['input']>;
  quantity?: InputMaybe<Scalars['String']['input']>;
  rowIndex: Scalars['Int']['input'];
  type?: InputMaybe<Scalars['String']['input']>;
  unitCost?: InputMaybe<Scalars['String']['input']>;
};

export type ValidateMaintenanceImportResponse = {
  __typename?: 'ValidateMaintenanceImportResponse';
  invalidRows: Array<ValidateMaintenanceInvalidRowsResponse>;
  validRows: Array<ValidateMaintenanceValidRowsResponse>;
};

export type ValidateMaintenanceInvalidPart = {
  __typename?: 'ValidateMaintenanceInvalidPart';
  partName?: Maybe<Scalars['String']['output']>;
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['String']['output']>;
  unitCost?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRow = {
  __typename?: 'ValidateMaintenanceInvalidRow';
  items?: Maybe<Array<Maybe<ValidateMaintenanceAggregatedPart>>>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  maintenanceObservation?: Maybe<Scalars['String']['output']>;
  occurrenceAt?: Maybe<Scalars['String']['output']>;
  odometerInKms?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

export type ValidateMaintenanceInvalidRowItem = {
  __typename?: 'ValidateMaintenanceInvalidRowItem';
  errors: Array<ValidationError>;
  itemsData: ValidateMaintenanceInvalidPart;
  rowIndex: Scalars['Int']['output'];
};

export type ValidateMaintenanceInvalidRowsResponse = {
  __typename?: 'ValidateMaintenanceInvalidRowsResponse';
  errors: Array<ValidationError>;
  items: Array<ValidateMaintenanceInvalidRowItem>;
  maintenanceData: ValidateMaintenanceInvalidRow;
};

export type ValidateMaintenancePart = {
  __typename?: 'ValidateMaintenancePart';
  partName: Scalars['String']['output'];
  partObservation?: Maybe<Scalars['String']['output']>;
  quantity?: Maybe<Scalars['Int']['output']>;
  unitCost: Scalars['Float']['output'];
};

export type ValidateMaintenanceValidRowsResponse = {
  __typename?: 'ValidateMaintenanceValidRowsResponse';
  maintenanceObservations?: Maybe<Scalars['String']['output']>;
  occurrenceAt: Scalars['DateTime']['output'];
  odometerInKms: Scalars['Float']['output'];
  parts: Array<ValidateMaintenancePart>;
  type: Array<Scalars['String']['output']>;
  vehicle: VehicleDto;
};

export type ValidationError = {
  __typename?: 'ValidationError';
  column: ImportColumnMap;
  error: Scalars['String']['output'];
};

export type VehicleDto = {
  __typename?: 'VehicleDTO';
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  cobliId?: Maybe<Scalars['String']['output']>;
  device?: Maybe<Device>;
  deviceType?: Maybe<Scalars['String']['output']>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<VehicleDriverDto>;
  esn?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  groupPath: Scalars['String']['output'];
  groups: Array<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  model: VehicleModelDto;
  odometer?: Maybe<VehicleOdometer>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tagId?: Maybe<Scalars['String']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehicleDeviceAssociationInfo = {
  __typename?: 'VehicleDeviceAssociationInfo';
  device?: Maybe<Device>;
  duration?: Maybe<Scalars['Int']['output']>;
  event?: Maybe<Scalars['String']['output']>;
  eventDate?: Maybe<Scalars['String']['output']>;
  fleetId?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  userEmail?: Maybe<Scalars['String']['output']>;
  vehicle?: Maybe<VehicleDto>;
};

export type VehicleDeviceAssociationInfoInput = {
  endDate?: InputMaybe<Scalars['String']['input']>;
  startDate?: InputMaybe<Scalars['String']['input']>;
  wantedDeviceIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedEvents?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedUsers?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  wantedVehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehicleDeviceAssociationInfoResponse = {
  __typename?: 'VehicleDeviceAssociationInfoResponse';
  associations: Array<VehicleDeviceAssociationInfo>;
  count?: Maybe<Scalars['Int']['output']>;
};

export type VehicleDriverAuthorization = {
  __typename?: 'VehicleDriverAuthorization';
  authorizations?: Maybe<Array<DriverAuthorization>>;
  vehicle: VehicleDto;
};

export enum VehicleDriverAuthorizationStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Processing = 'PROCESSING',
}

export type VehicleDriverDto = {
  __typename?: 'VehicleDriverDTO';
  active?: Maybe<Scalars['Boolean']['output']>;
  firstLicenseAcquirementDate?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
  licenseCategory?: Maybe<Scalars['String']['output']>;
  licenseExpirationDate?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  phoneNumbers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type VehicleExpense = {
  __typename?: 'VehicleExpense';
  categoryCosts: Array<CategoryCost>;
  costPerKm: Scalars['Float']['output'];
  distanceDrivenInKm: Scalars['Float']['output'];
  previousPeriodCostPerKm: Scalars['Float']['output'];
  previousPeriodTotalCost: Scalars['Float']['output'];
  totalCost: Scalars['Float']['output'];
  vehicle: ExpenseVehicle;
};

export type VehicleExpensesPaginatedResponse = {
  __typename?: 'VehicleExpensesPaginatedResponse';
  content: Array<VehicleExpense>;
  empty: Scalars['Boolean']['output'];
  first: Scalars['Boolean']['output'];
  last: Scalars['Boolean']['output'];
  number: Scalars['Int']['output'];
  numberOfElements: Scalars['Int']['output'];
  size: Scalars['Int']['output'];
  totalElements: Scalars['Int']['output'];
  totalPages: Scalars['Int']['output'];
};

export type VehicleFields = {
  __typename?: 'VehicleFields';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fuelConsumption?: Maybe<Scalars['Float']['output']>;
  fuelPrice?: Maybe<Scalars['Float']['output']>;
  id: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
};

export type VehicleGroupDto = {
  __typename?: 'VehicleGroupDTO';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type VehicleImages = {
  __typename?: 'VehicleImages';
  images?: Maybe<Array<Maybe<TripImageDetails>>>;
  vehicle?: Maybe<VehicleDto>;
  vehicle_id?: Maybe<Scalars['String']['output']>;
};

export type VehicleInfo = {
  __typename?: 'VehicleInfo';
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  plate: Scalars['String']['output'];
  vin: Scalars['String']['output'];
  year: Scalars['Int']['output'];
};

export type VehicleInformation = {
  __typename?: 'VehicleInformation';
  licensePlates?: Maybe<Scalars['String']['output']>;
  models?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastAssociation = {
  __typename?: 'VehicleLastAssociation';
  alias?: Maybe<Scalars['String']['output']>;
  brand?: Maybe<Scalars['String']['output']>;
  fleetId: Scalars['ID']['output'];
  licensePlate?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vehicleId?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleLastLocationDto = {
  __typename?: 'VehicleLastLocationDTO';
  cobliIngestedAt?: Maybe<Scalars['Float']['output']>;
  isPlugged?: Maybe<Scalars['Boolean']['output']>;
  timeInMillis?: Maybe<Scalars['Float']['output']>;
};

export type VehicleModelDto = {
  __typename?: 'VehicleModelDTO';
  brand?: Maybe<Scalars['String']['output']>;
  isSuggestion?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  version?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
};

export type VehicleOdometer = {
  __typename?: 'VehicleOdometer';
  createdAt: Scalars['TimestampInMillis']['output'];
  createdByUserName?: Maybe<Scalars['String']['output']>;
  createdOdometerInKm: Scalars['Long']['output'];
  odometerDateAt: Scalars['TimestampInMillis']['output'];
  odometerInKm: Scalars['Long']['output'];
  vehicleId: Scalars['ID']['output'];
};

export type VehiclePastAssociationDto = {
  __typename?: 'VehiclePastAssociationDTO';
  associatedAt: Scalars['String']['output'];
  associatedBy?: Maybe<FleetUser>;
  driver?: Maybe<VehicleDriverDto>;
  identificationMethod?: Maybe<Scalars['String']['output']>;
};

export type VehicleSpeedLimitAlert = UserAlert & {
  __typename?: 'VehicleSpeedLimitAlert';
  driver?: Maybe<Driver>;
  driver_id?: Maybe<Scalars['ID']['output']>;
  duration_in_millis?: Maybe<Scalars['Int']['output']>;
  id: Scalars['ID']['output'];
  processed_at: Scalars['Float']['output'];
  speed_in_km_h?: Maybe<Scalars['Int']['output']>;
  speed_limit_in_km_h?: Maybe<Scalars['Int']['output']>;
  type: UserNotificationSettingsType;
  vehicle_group_id?: Maybe<Scalars['ID']['output']>;
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleSpeedLimitSettings = {
  __typename?: 'VehicleSpeedLimitSettings';
  duration_above_limit_in_millis: Scalars['Int']['output'];
  vehicle_group_ids: Array<Maybe<Scalars['ID']['output']>>;
};

export type VehicleSuggestionEntry = {
  __typename?: 'VehicleSuggestionEntry';
  key: Scalars['String']['output'];
  value?: Maybe<VehicleInfo>;
};

export type VehicleTag = {
  __typename?: 'VehicleTag';
  name: Scalars['String']['output'];
};

export type VehicleTrackingInput = {
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
  with_jumps?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VehicleTrackingSegmentInput = {
  allow_unfinished_step?: InputMaybe<Scalars['Boolean']['input']>;
  end_time: Scalars['Float']['input'];
  match?: InputMaybe<Scalars['Boolean']['input']>;
  segment_end: Scalars['Float']['input'];
  segment_start: Scalars['Float']['input'];
  start_time: Scalars['Float']['input'];
  tz: Scalars['String']['input'];
  vehicle_id: Scalars['ID']['input'];
};

export type VehicleTrackingSegmentType = {
  __typename?: 'VehicleTrackingSegmentType';
  end_time: Scalars['Float']['output'];
  has_route_steps?: Maybe<Scalars['Boolean']['output']>;
  match?: Maybe<Scalars['Boolean']['output']>;
  mediaEvents?: Maybe<Array<Maybe<Media>>>;
  start_time: Scalars['Float']['output'];
  tracking?: Maybe<Tracking>;
  tz: Scalars['String']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTrackingSegmentTypeMediaEventsArgs = {
  event_triggers?: InputMaybe<Array<InputMaybe<EventTrigger>>>;
  media_types?: InputMaybe<Array<InputMaybe<MediaType>>>;
};

export type VehicleTripDistance = {
  __typename?: 'VehicleTripDistance';
  distance_driven_in_meters: Scalars['Float']['output'];
  vehicle_id: Scalars['ID']['output'];
};

export type VehicleTripDistanceInput = {
  begin: Scalars['TimestampInMillis']['input'];
  end: Scalars['TimestampInMillis']['input'];
  timezone: Scalars['String']['input'];
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VehicleTripDistanceResponse = {
  __typename?: 'VehicleTripDistanceResponse';
  content: Array<VehicleTripDistance>;
};

export type VehicleV1 = {
  __typename?: 'VehicleV1';
  alias?: Maybe<Scalars['String']['output']>;
  branding?: Maybe<Branding>;
  device?: Maybe<Device>;
  disablerStatus?: Maybe<DisablerDto>;
  driver?: Maybe<Driver>;
  fleetId: Scalars['String']['output'];
  fuel?: Maybe<FuelDto>;
  groupPath: Scalars['String']['output'];
  groups?: Maybe<VehicleGroupDto>;
  id: Scalars['ID']['output'];
  immobilizerStatus?: Maybe<VehicleDriverAuthorizationStatus>;
  isAllowListEnabled?: Maybe<Scalars['Boolean']['output']>;
  isImmobilizerEnabled?: Maybe<Scalars['Boolean']['output']>;
  lastLocation?: Maybe<VehicleLastLocationDto>;
  licensePlate?: Maybe<Scalars['String']['output']>;
  odometer?: Maybe<VehicleOdometer>;
  size?: Maybe<Scalars['String']['output']>;
  speedLimitInKmh?: Maybe<Scalars['Float']['output']>;
  tags?: Maybe<Array<VehicleTag>>;
  vehicleDriverAuthorizationMode: Scalars['String']['output'];
};

export type VehiclesExpensesInput = {
  endDate: Scalars['DateTime']['input'];
  page?: InputMaybe<Scalars['Int']['input']>;
  searchQuery?: InputMaybe<Scalars['String']['input']>;
  size?: InputMaybe<Scalars['Int']['input']>;
  sortCategoryId?: InputMaybe<Scalars['ID']['input']>;
  sortDirection?: InputMaybe<Scalars['String']['input']>;
  sortField?: InputMaybe<Scalars['String']['input']>;
  startDate: Scalars['DateTime']['input'];
  tagNames?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  timezone: Scalars['String']['input'];
  vehicleGroupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleModels?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  vehicleSizes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type VehiclesGroup = {
  __typename?: 'VehiclesGroup';
  createdAt: Scalars['TimestampInMillis']['output'];
  creatorId: Scalars['ID']['output'];
  fleetId: Scalars['ID']['output'];
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  path: Scalars['String']['output'];
  updatedAt: Scalars['TimestampInMillis']['output'];
  users: Array<Maybe<FleetUser>>;
  vehicles: Array<VehicleDto>;
};

export type VehiclesGroupInput = {
  fleetId?: InputMaybe<Scalars['ID']['input']>;
  name: Scalars['String']['input'];
  userIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  vehicleIds: Array<Scalars['ID']['input']>;
};

export type VideoDto = {
  __typename?: 'VideoDTO';
  /** Channel in which the video was recorded */
  channel?: Maybe<Scalars['String']['output']>;
  /** Video URL on storage */
  url?: Maybe<Scalars['String']['output']>;
};

export type VideoInfo = {
  category: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type WantedDriverId = {
  driverId: Scalars['ID']['input'];
};

export type WantedDrivers = {
  driverIds: Array<Scalars['ID']['input']>;
};

export type WifiSetting = {
  __typename?: 'WifiSetting';
  /** The date and time the wifi setting was created. */
  created_at: Scalars['DateTime']['output'];
  /** The name of the user who created the wifi setting. */
  created_by: Scalars['String']['output'];
  /** The id of the wifi setting. */
  id: Scalars['ID']['output'];
  /** The ssid of the wifi setting. */
  ssid: Scalars['String']['output'];
};

export type WorkingHours = {
  __typename?: 'WorkingHours';
  end_time: Scalars['TimestampInMillis']['output'];
  start_time: Scalars['TimestampInMillis']['output'];
};

export type WorkingHoursInput = {
  end_time: Scalars['TimestampInMillis']['input'];
  start_time: Scalars['TimestampInMillis']['input'];
};

export type ExecutionDigestSummary = {
  __typename?: 'executionDigestSummary';
  ids: Array<Scalars['ID']['output']>;
  total: Scalars['Int']['output'];
};

export type VehicleFragment = {
  __typename?: 'VehicleDTO';
  id: string;
  licensePlate?: string | null;
  size?: string | null;
  model: {
    __typename?: 'VehicleModelDTO';
    brand?: string | null;
    name?: string | null;
    year?: string | null;
    version?: string | null;
    isSuggestion?: boolean | null;
    type?: string | null;
  };
  groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
  driver?: {
    __typename?: 'VehicleDriverDTO';
    id?: string | null;
    name?: string | null;
    phoneNumbers?: Array<string | null> | null;
    active?: boolean | null;
    firstLicenseAcquirementDate?: string | null;
    licenseExpirationDate?: string | null;
    licenseCategory?: string | null;
  } | null;
};

export type LastLocationFragment = {
  __typename?: 'LastLocation';
  cobliIngestedAt?: number | null;
  timeInMillis?: number | null;
  longitude?: number | null;
  latitude?: number | null;
  speed?: number | null;
  heading?: number | null;
  isPlugged?: boolean | null;
  ignitionOn?: boolean | null;
  pluggedUpdateTimestamp?: number | null;
  idleOnDurationInMillis?: number | null;
  idleOffDurationInMillis?: number | null;
};

export type TrackingFragment = {
  __typename?: 'DeviceTracking';
  tempGeofenceId?: string | null;
  conclusionTime?: string | null;
  destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
};

export type DeviceActiveObservationPeriodTriggerFragment = { __typename?: 'Trigger'; createdAt: string };

export type DeviceFragment = {
  __typename?: 'Device';
  id: string;
  cobliId: string;
  fleetId: string;
  type: DeviceType;
  generalType: DeviceGeneralType;
  deviceModel?: string | null;
  healthStatus: DeviceHealthStatusType;
  generalStatus: DeviceGeneralStatus;
  isNew: boolean;
  associatedAt: any;
  sdCardHealthStatus?: DeviceSdCardHealthStatus | null;
  disablerStatus?: DisablerStatus | null;
  lastMovingStateTime?: string | null;
  statusSummary: { __typename?: 'DeviceStatusSummary'; status: DeviceStatusType; causes: Array<{ __typename?: 'DeviceCause'; cause: DeviceCauseKey; status: DeviceStatusType }> };
  tracking?: {
    __typename?: 'DeviceTracking';
    tempGeofenceId?: string | null;
    conclusionTime?: string | null;
    destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
  } | null;
  lastLocation?: {
    __typename?: 'LastLocation';
    cobliIngestedAt?: number | null;
    timeInMillis?: number | null;
    longitude?: number | null;
    latitude?: number | null;
    speed?: number | null;
    heading?: number | null;
    isPlugged?: boolean | null;
    ignitionOn?: boolean | null;
    pluggedUpdateTimestamp?: number | null;
    idleOnDurationInMillis?: number | null;
    idleOffDurationInMillis?: number | null;
  } | null;
  vehicle?: {
    __typename?: 'VehicleDTO';
    id: string;
    licensePlate?: string | null;
    size?: string | null;
    model: {
      __typename?: 'VehicleModelDTO';
      brand?: string | null;
      name?: string | null;
      year?: string | null;
      version?: string | null;
      isSuggestion?: boolean | null;
      type?: string | null;
    };
    groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
    driver?: {
      __typename?: 'VehicleDriverDTO';
      id?: string | null;
      name?: string | null;
      phoneNumbers?: Array<string | null> | null;
      active?: boolean | null;
      firstLicenseAcquirementDate?: string | null;
      licenseExpirationDate?: string | null;
      licenseCategory?: string | null;
    } | null;
  } | null;
  activeObservationPeriodTrigger?: { __typename?: 'Trigger'; createdAt: string } | null;
};

export type DevicesQueryVariables = Exact<{
  includeLastMovingStateTime: Scalars['Boolean']['input'];
  includeLastLocation: Scalars['Boolean']['input'];
  includeVehicle: Scalars['Boolean']['input'];
  includeDisablerStatus: Scalars['Boolean']['input'];
  includeTracking: Scalars['Boolean']['input'];
  includeObservationPeriodTrigger: Scalars['Boolean']['input'];
  groupIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
}>;

export type DevicesQuery = {
  __typename?: 'Query';
  devices: Array<{
    __typename?: 'Device';
    id: string;
    cobliId: string;
    fleetId: string;
    type: DeviceType;
    generalType: DeviceGeneralType;
    deviceModel?: string | null;
    healthStatus: DeviceHealthStatusType;
    generalStatus: DeviceGeneralStatus;
    isNew: boolean;
    associatedAt: any;
    sdCardHealthStatus?: DeviceSdCardHealthStatus | null;
    disablerStatus?: DisablerStatus | null;
    lastMovingStateTime?: string | null;
    statusSummary: { __typename?: 'DeviceStatusSummary'; status: DeviceStatusType; causes: Array<{ __typename?: 'DeviceCause'; cause: DeviceCauseKey; status: DeviceStatusType }> };
    tracking?: {
      __typename?: 'DeviceTracking';
      tempGeofenceId?: string | null;
      conclusionTime?: string | null;
      destination?: { __typename?: 'DeviceDestination'; address?: string | null; lat?: number | null; lng?: number | null } | null;
    } | null;
    lastLocation?: {
      __typename?: 'LastLocation';
      cobliIngestedAt?: number | null;
      timeInMillis?: number | null;
      longitude?: number | null;
      latitude?: number | null;
      speed?: number | null;
      heading?: number | null;
      isPlugged?: boolean | null;
      ignitionOn?: boolean | null;
      pluggedUpdateTimestamp?: number | null;
      idleOnDurationInMillis?: number | null;
      idleOffDurationInMillis?: number | null;
    } | null;
    vehicle?: {
      __typename?: 'VehicleDTO';
      id: string;
      licensePlate?: string | null;
      size?: string | null;
      model: {
        __typename?: 'VehicleModelDTO';
        brand?: string | null;
        name?: string | null;
        year?: string | null;
        version?: string | null;
        isSuggestion?: boolean | null;
        type?: string | null;
      };
      groups: Array<{ __typename?: 'VehicleGroupDTO'; id: string; name: string }>;
      driver?: {
        __typename?: 'VehicleDriverDTO';
        id?: string | null;
        name?: string | null;
        phoneNumbers?: Array<string | null> | null;
        active?: boolean | null;
        firstLicenseAcquirementDate?: string | null;
        licenseExpirationDate?: string | null;
        licenseCategory?: string | null;
      } | null;
    } | null;
    activeObservationPeriodTrigger?: { __typename?: 'Trigger'; createdAt: string } | null;
  }>;
};

export type LastDeviceAssociationQueryVariables = Exact<{
  deviceId: Scalars['String']['input'];
}>;

export type LastDeviceAssociationQuery = {
  __typename?: 'Query';
  lastAssociation?: {
    __typename?: 'LastAssociation';
    cobliId?: string | null;
    deviceId?: string | null;
    fleetId: string;
    driver?: { __typename?: 'DriverLastAssociation'; driverId?: string | null; driverName?: string | null } | null;
    lastLocation?: {
      __typename?: 'LastLocation';
      deviceId: string;
      time?: number | null;
      timeInMillis?: number | null;
      latitude?: number | null;
      longitude?: number | null;
      heading?: number | null;
      speed?: number | null;
      ignitionOn?: boolean | null;
      cobliIngestedAt?: number | null;
      processedAt?: number | null;
      isPlugged?: boolean | null;
      pluggedUpdateTimestamp?: number | null;
      idleOnDurationInMillis?: number | null;
      idleOffDurationInMillis?: number | null;
    } | null;
    vehicle?: {
      __typename?: 'VehicleLastAssociation';
      vehicleId?: string | null;
      fleetId: string;
      licensePlate?: string | null;
      model?: string | null;
      brand?: string | null;
      year?: string | null;
      type?: string | null;
    } | null;
  } | null;
};

export type AssignDriverToDeviceMutationVariables = Exact<{
  input: DriverAssignmentInput;
}>;

export type AssignDriverToDeviceMutation = { __typename?: 'Mutation'; assignDriverToDevice?: boolean | null };

export type UnassignDriverToDeviceMutationVariables = Exact<{
  input: DriverAssignmentInput;
}>;

export type UnassignDriverToDeviceMutation = { __typename?: 'Mutation'; unassignDriverToDevice?: boolean | null };

export type LastPathQueryVariables = Exact<{
  input: LastPathInput;
}>;

export type LastPathQuery = { __typename?: 'Query'; lastPath?: { __typename?: 'LastPath'; event_time: any } | null };

export const TrackingFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<TrackingFragment, unknown>;
export const LastLocationFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastLocationFragment, unknown>;
export const VehicleFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<VehicleFragment, unknown>;
export const DeviceActiveObservationPeriodTriggerFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
  ],
} as unknown as DocumentNode<DeviceActiveObservationPeriodTriggerFragment, unknown>;
export const DeviceFragmentDoc = {
  kind: 'Document',
  definitions: [
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Device' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Device' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sdCardHealthStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'causes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cause' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disablerStatus' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMovingStateTime' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Tracking' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastLocation' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LastLocation' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicle' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Vehicle' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeObservationPeriodTrigger' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  { kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } } },
                ],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
  ],
} as unknown as DocumentNode<DeviceFragment, unknown>;
export const DevicesDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'devices' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'Boolean' } } },
        },
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } },
          type: { kind: 'ListType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'devices' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'groupIds' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'groupIds' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Device' } }] },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Tracking' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'DeviceTracking' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'destination' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'address' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lat' } },
                { kind: 'Field', name: { kind: 'Name', value: 'lng' } },
              ],
            },
          },
          { kind: 'Field', name: { kind: 'Name', value: 'tempGeofenceId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'conclusionTime' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'LastLocation' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'LastLocation' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
          { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
          { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
          { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
          { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
          { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Vehicle' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'VehicleDTO' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
          { kind: 'Field', name: { kind: 'Name', value: 'size' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'model' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                { kind: 'Field', name: { kind: 'Name', value: 'version' } },
                { kind: 'Field', name: { kind: 'Name', value: 'isSuggestion' } },
                { kind: 'Field', name: { kind: 'Name', value: 'type' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'groups' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'driver' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                { kind: 'Field', name: { kind: 'Name', value: 'name' } },
                { kind: 'Field', name: { kind: 'Name', value: 'phoneNumbers' } },
                { kind: 'Field', name: { kind: 'Name', value: 'active' } },
                { kind: 'Field', name: { kind: 'Name', value: 'firstLicenseAcquirementDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseExpirationDate' } },
                { kind: 'Field', name: { kind: 'Name', value: 'licenseCategory' } },
              ],
            },
          },
        ],
      },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Trigger' } },
      selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'createdAt' } }] },
    },
    {
      kind: 'FragmentDefinition',
      name: { kind: 'Name', value: 'Device' },
      typeCondition: { kind: 'NamedType', name: { kind: 'Name', value: 'Device' } },
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          { kind: 'Field', name: { kind: 'Name', value: 'id' } },
          { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
          { kind: 'Field', name: { kind: 'Name', value: 'type' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalType' } },
          { kind: 'Field', name: { kind: 'Name', value: 'deviceModel' } },
          { kind: 'Field', name: { kind: 'Name', value: 'healthStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'generalStatus' } },
          { kind: 'Field', name: { kind: 'Name', value: 'isNew' } },
          { kind: 'Field', name: { kind: 'Name', value: 'associatedAt' } },
          { kind: 'Field', name: { kind: 'Name', value: 'sdCardHealthStatus' } },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'statusSummary' },
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'causes' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'cause' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                    ],
                  },
                },
              ],
            },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'disablerStatus' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeDisablerStatus' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastMovingStateTime' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastMovingStateTime' } } }],
              },
            ],
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'tracking' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeTracking' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Tracking' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastLocation' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeLastLocation' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'LastLocation' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'vehicle' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeVehicle' } } }],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'Vehicle' } }] },
          },
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'activeObservationPeriodTrigger' },
            directives: [
              {
                kind: 'Directive',
                name: { kind: 'Name', value: 'include' },
                arguments: [
                  { kind: 'Argument', name: { kind: 'Name', value: 'if' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'includeObservationPeriodTrigger' } } },
                ],
              },
            ],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'FragmentSpread', name: { kind: 'Name', value: 'DeviceActiveObservationPeriodTrigger' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<DevicesQuery, DevicesQueryVariables>;
export const LastDeviceAssociationDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'lastDeviceAssociation' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'String' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastAssociation' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'deviceId' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'deviceId' } } }],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'cobliId' } },
                { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'driver' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'driverId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'driverName' } },
                    ],
                  },
                },
                { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'lastLocation' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'deviceId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'time' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'timeInMillis' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'latitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'longitude' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'heading' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'speed' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'ignitionOn' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'cobliIngestedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'processedAt' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'isPlugged' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'pluggedUpdateTimestamp' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idleOnDurationInMillis' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'idleOffDurationInMillis' } },
                    ],
                  },
                },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'vehicle' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'vehicleId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'fleetId' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'licensePlate' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'model' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'brand' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'year' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'type' } },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastDeviceAssociationQuery, LastDeviceAssociationQueryVariables>;
export const AssignDriverToDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'AssignDriverToDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverAssignmentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'assignDriverToDevice' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<AssignDriverToDeviceMutation, AssignDriverToDeviceMutationVariables>;
export const UnassignDriverToDeviceDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'UnassignDriverToDevice' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'DriverAssignmentInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'unassignDriverToDevice' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<UnassignDriverToDeviceMutation, UnassignDriverToDeviceMutationVariables>;
export const LastPathDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'query',
      name: { kind: 'Name', value: 'LastPath' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'input' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'LastPathInput' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'lastPath' },
            arguments: [{ kind: 'Argument', name: { kind: 'Name', value: 'input' }, value: { kind: 'Variable', name: { kind: 'Name', value: 'input' } } }],
            selectionSet: { kind: 'SelectionSet', selections: [{ kind: 'Field', name: { kind: 'Name', value: 'event_time' } }] },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<LastPathQuery, LastPathQueryVariables>;
